<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.auName" style="width: 140px;" size="small " placeholder="请输入名称"
                        clearable></el-input>
                    <el-input v-model="formDatas.auInterviewer" style="width: 140px;" size="small " placeholder="请输入面试官"
                        clearable></el-input>
                    <el-input v-model="formDatas.auIdcard" style="width: 140px;" size="small " placeholder="请输入身份证"
                        clearable></el-input>
                    <el-input v-model="formDatas.auContactMine" style="width: 140px;" size="small "
                        placeholder="请输入联系方式" clearable></el-input>
                    <el-select size="small" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select>
                    <!-- <el-select size="small" v-model="formDatas.checkStatus" clearable @change="partserch"
                        placeholder="请选择审核状态" style="width: 130px">
                        <el-option label="否" :value="1" key="1"></el-option>
                        <el-option label="是" :value="2" key="2"></el-option>

                    </el-select> -->
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="info" size="small" icon="el-icon-search" @click="SerchMore"
                        style="margin-left: 10px">更多搜索</el-button> -->
                    <!-- <el-button type="primary" size="small" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                    <!-- <el-dropdown size="small" split-button type="warning" style="margin-right: 10px;" @click="Out()"
                        @command="Out">
                        导出
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item style="background-color: #E6A23C;color: white;"
                                command="1">导出全部</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown> -->
                    <!-- <el-button type="primary" size="small" style="margin-right: 20px" @click="Handleword">word模板</el-button> -->
                    <!-- <el-button type="primary" size="small" style="margin-left: 20px"
                        @click="SynchronizeUpdates">同步更新</el-button> -->
                    <el-button type="primary" size="small" style="margin-left: 20px"
                        @click="batchWord">导出word</el-button>
                    <!-- <el-button type="primary" size="small" style="margin-left: 20px"
                        @click="IsdepartmentClick">批量修改部门</el-button> -->

                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增花名册</el-button> -->

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="auId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑花名册' : '新增花名册'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="身份证正面(人像面)" prop="auIdcardUp">
                                <my-uploadTwo ref="upcard" @fileChange="auIdcardUpfileChange" :filearr="UpfileList"
                                    :limit="limit" @removeAfter="UpremoveAfter" apiType="cardUp"
                                    style="margin: 10px 5px 5px;">
                                </my-uploadTwo>
                                <!-- <el-input v-model="form.auIdcardUp" style="width: 80%;" placeholder="请先上传身份证正面(人像面)"
                                    disabled></el-input> -->
                            </el-form-item>
                            <el-form-item label="身份证反面(国徽面)" prop="auIdcardDown">
                                <my-uploadTwo ref="Downcard" @fileChange="auIdcardDownfileChange"
                                    :filearr="DownfileList" :limit="limit" apiType="cardDown"
                                    style="margin: 10px 5px 5px;">
                                </my-uploadTwo>
                                <!-- <el-input v-model="form.auIdcardDown" style="width: 80%;" placeholder="请先上传身份证反面(国徽面)"
                                    disabled></el-input> -->
                            </el-form-item>
                            <!-- 身份证生成 -->


                            <el-form-item label="姓名" prop="auName">
                                <el-input v-model="form.auName" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="性别" prop="auSex">
                                <el-input v-model="form.auSex" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="年龄" prop="auAge">
                                <el-input v-model="form.auAge" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item> -->
                            <el-form-item label="籍贯" prop="auOrigin">
                                <el-cascader v-model="auOriginvalue" :options="auOriginArr" :props="props"
                                    ref="cascader" @change="handleChange" @expand-change="expandChange"
                                    :placeholder="auOriginPL" style="width: 90%;"></el-cascader>
                                <!-- <el-input v-model="form.auOrigin" style="width: 80%;" placeholder="请输入"></el-input> -->
                            </el-form-item>
                            <el-form-item label="户口所在地" prop="auAddressRegistered">
                                <el-input v-model="form.auAddressRegistered" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="民族" prop="auNation">
                                <el-select v-model="form.auNation" placeholder="请选择">
                                    <el-option v-for="item in auNationArr || []" :label="item.snName"
                                        :value="item.snName" :key="item.snId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="出生年月" prop="auBirth">
                                <el-date-picker v-model="form.auBirth" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="身份证号码" prop="auIdcard">
                                <el-input v-model="form.auIdcard" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="身份证完整地址" prop="auIdcardAddress">
                                <el-input v-model="form.auIdcardAddress" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="发证机关" prop="auIdcardIssuingAuthority">
                                <el-input v-model="form.auIdcardIssuingAuthority" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="身份证有效期" prop="auIdcardExpiration">
                                <el-date-picker v-model="form.auIdcardExpiration" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item> -->
                            <el-form-item label="入职时间" prop="auDateEntry">
                                <el-date-picker v-model="form.auDateEntry" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="所在部门" prop="auDepartment">
                                <el-input v-model="form.auDepartment" style="width: 80%;" placeholder="请输入"></el-input>
                                <!-- <el-cascader v-model="form.auDepartment" :options="auDepartmentArr" :show-all-levels="false"
                    :props="{ checkStrictly: true }"></el-cascader> -->
                            </el-form-item>
                            <el-form-item label="职务" prop="auPost">
                                <el-input v-model="form.auPost" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>

                            <el-form-item label="归属" prop="auBelong">
                                <!-- <el-input v-model="form.auBelong" style="width: 80%;" placeholder="请输入"></el-input> -->
                                <el-select v-model="form.auBelong" placeholder="请选择" filterable clearable>
                                    <el-option v-for="item in aubName_arr || []" :label="item.aubName"
                                        :value="item.aubName" :key="item.aubId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="是否深户" prop="auSh" v-if="form.auBelong === '深圳'">
                                <el-select v-model="form.auSh" placeholder="请选择" clearable>
                                    <el-option label="是" value="是"></el-option>
                                    <el-option label="否" value="否"></el-option>
                                </el-select>
                            </el-form-item>
                            <!-- <el-form-item label="试用期(月)" prop="auProbationPeriod">
                                <el-select v-model="form.auProbationPeriod" placeholder="请选择">
                                    <el-option v-for="item in auprobationArr || []" :label="item.key" :value="item.value"
                                        :key="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item> -->
                            <el-form-item label="试用期结束时间" prop="auDateRegular">
                                <el-date-picker v-model="form.auDateRegular" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="认证通关/调整部门时间" prop="auDateTransfer">
                                <el-date-picker v-model="form.auDateTransfer" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>

                            <el-form-item label="状态" prop="auStatus">
                                <el-input v-model="form.auStatus" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="面试官" prop="auInterviewer">
                                <el-input v-model="form.auInterviewer" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="合同到期时间" prop="auDateExpirationContract">
                                <el-date-picker v-model="form.auDateExpirationContract" type="date"
                                    value-format="yyyy-MM-dd" placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>


                            <!-- <el-form-item label="政治面貌" prop="auPolitical">
                                <el-select v-model="form.auPolitical" placeholder="请选择">
                                    <el-option v-for="item in auPoliticalArr || []" :label="item.key" :value="item.value"
                                        :key="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item> -->
                            <!-- <el-form-item label="户口性质" prop="auAddressRegisteredType">
                                <el-select v-model="form.auAddressRegisteredType" placeholder="请选择">
                                    <el-option v-for="item in auAddressRegisteredTypeArr || []" :label="item.key"
                                        :value="item.value" :key="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item> -->

                            <el-form-item label="婚姻状态" prop="auMarital">
                                <el-select v-model="form.auMarital" placeholder="请选择">
                                    <el-option v-for="item in auMaritalArr || []" :label="item.key" :value="item.value"
                                        :key="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="配偶姓名" prop="auMaritalSpouseName">
                                <el-input v-model="form.auMaritalSpouseName" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="配偶身份证号" prop="auMaritalSpouseIdcard">
                                <el-input v-model="form.auMaritalSpouseIdcard" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="毕业院校" prop="auSchool">
                                <el-input v-model="form.auSchool" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="专业" prop="auMajor">
                                <el-input v-model="form.auMajor" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="最高学历" prop="auEducationLevel">
                                <el-select v-model="education" placeholder="请选择">
                                    <el-option label="全日制" value="全日制" :key="1">
                                    </el-option>
                                    <el-option label="非全日制" value="非全日制" :key="2">
                                    </el-option>
                                </el-select>
                                <el-select v-model="form.auEducationLevel" placeholder="请选择">

                                    <el-option label="博士研究生" value="博士研究生" :key="2">
                                    </el-option>
                                    <el-option label="硕士研究生" value="硕士研究生" :key="3">
                                    </el-option>
                                    <el-option label="本科" value="本科" :key="4">
                                    </el-option>
                                    <el-option label="大专" value="大专" :key="1">
                                    </el-option>
                                    <el-option label="其他" value="其他" :key="5">
                                    </el-option>

                                </el-select>
                                <!-- <el-input v-model="form.auEducationLevel" style="width: 80%;" placeholder="请输入"></el-input> -->
                            </el-form-item>
                            <el-form-item label="毕业时间" prop="auGraduationTime">
                                <el-date-picker v-model="form.auGraduationTime" type="month" @change="$forceUpdate()"
                                    value-format="yyyy-MM" placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="学历证书(图片)" prop="auCertificateEducation">
                                <my-uploadTwo ref="xlupload" @fileChange="XlfileChange" :filearr="xlfileList"
                                    :limit="limit" style="margin: 10px 5px 5px;">
                                </my-uploadTwo>
                            </el-form-item>
                            <el-form-item label="学历证书查验证明(图片)" prop="auCertificateEducationCheck">
                                <my-uploadTwo ref="Cyupload" @fileChange="CyfileChange" :filearr="CyfileList"
                                    :limit="limit" style="margin: 10px 5px 5px;">
                                </my-uploadTwo>
                            </el-form-item>
                            <!-- <el-form-item label="最高学历" prop="auEducationLevelMax">
                                <el-input v-model="form.auEducationLevelMax" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item> -->
                            <!-- <el-form-item label="浦发银行卡号" prop="auBankCardPf">
                                <el-input v-model="form.auBankCardPf" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item> -->
                            <el-form-item label="银行名称" prop="auBankCardOther">
                                <el-input v-model="form.auBankCardOther" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="银行卡号" prop="auBankCardOtherNum">
                                <el-input v-model="form.auBankCardOtherNum" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户城市" prop="auBankCardOtherOpen">
                                <el-input v-model="form.auBankCardOtherOpen" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="本人联系方式" prop="auContactMine">
                                <el-input v-model="form.auContactMine" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="个人邮箱" prop="auEmail">
                                <el-input v-model="form.auEmail" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item> -->
                            <el-form-item label="家庭主要成员">
                                <el-select v-model="familyShow" clearable placeholder="请选择" multiple>
                                    <el-option label="父亲" :value="1" :key="1">
                                    </el-option>
                                    <el-option label="母亲" :value="2" :key="2">
                                    </el-option>
                                    <!-- <el-option label="兄弟姐妹" :value="3" :key="3">
                                    </el-option> -->
                                </el-select>
                            </el-form-item>
                            <el-form-item label="父亲姓名" prop="auContactDad"
                                v-if="familyShow.indexOf(1) > -1 || form.auContactDad">
                                <el-input v-model="form.auContactDad" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="父亲工作单位" prop="auContactDadUnit"
                                v-if="familyShow.indexOf(1) > -1 || form.auContactDad">
                                <el-input v-model="form.auContactDadUnit" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="父亲联系方式" prop="auContactDadPhone"
                                v-if="familyShow.indexOf(1) > -1 || form.auContactDad">
                                <el-input v-model="form.auContactDadPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="母亲姓名" prop="auContactMom"
                                v-if="familyShow.indexOf(2) > -1 || form.auContactMom">
                                <el-input v-model="form.auContactMom" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="母亲工作单位" prop="auContactMomUnit"
                                v-if="familyShow.indexOf(2) > -1 || form.auContactMom">
                                <el-input v-model="form.auContactMomUnit" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="母亲联系方式" prop="auContactMomPhone"
                                v-if="familyShow.indexOf(2) > -1 || form.auContactMom">
                                <el-input v-model="form.auContactMomPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="兄弟姐妹姓名" prop="auContactSibling"
                                v-if="familyShow.indexOf(3) > -1 || form.auContactSibling">
                                <el-input v-model="form.auContactSibling" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="兄弟姐妹工作单位" prop="auContactSiblingUnit"
                                v-if="familyShow.indexOf(3) > -1 || form.auContactSibling">
                                <el-input v-model="form.auContactSiblingUnit" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="兄弟姐妹联系方式" prop="auContactSiblingPhone"
                                v-if="familyShow.indexOf(3) > -1 || form.auContactSibling">
                                <el-input v-model="form.auContactSiblingPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item> -->
                            <el-form-item label="同城紧急联系人姓名" prop="auContactEmergency">
                                <el-input v-model="form.auContactEmergency" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="深圳紧急联系人工作单位" prop="auContactEmergencyUnit">
                                <el-input v-model="form.auContactEmergencyUnit" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item> -->
                            <el-form-item label="同城紧急联系人联系方式" prop="auContactEmergencyPhone">
                                <el-input v-model="form.auContactEmergencyPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="现居住地址" prop="auAddressNow">
                                <el-cascader v-model="auAddressNowvalue" :options="auOriginArr" :props="props"
                                    ref="cascader2" @change="handleChange2" @expand-change="expandChange2"
                                    :placeholder="auAddressNowPL" style="width: 90%;"></el-cascader>
                                <el-input v-model="form.auAddressNow" style="width: 90%;margin-top:15px;"
                                    @input="$forceUpdate()" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="社保电脑号" prop="auSocialSecurityNum">
                                <el-input v-model="form.auSocialSecurityNum" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="公积金账号" prop="auProvidentFund" v-if="form.auFundShenzhenBefore == '是'">
                                <el-input v-model="form.auProvidentFund" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="公积金缴纳城市(最近)" prop="auFundOpenCityRecent"
                                v-if="form.auFundShenzhenBefore == '是'">
                                <el-input v-model="form.auFundOpenCityRecent" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="是否缴纳过公积金" prop="auFundShenzhenBefore">
                                <el-select v-model="form.auFundShenzhenBefore" placeholder="请选择">
                                    <el-option label="是" value="是"></el-option>
                                    <el-option label="否" value="否"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="首开公积金账号一类卡银行" prop="auFundOpenBank"
                                v-if="form.auFundShenzhenBefore == '否'">
                                <el-select v-model="form.auFundOpenBank" placeholder="请选择银行" style="width: 80%;">
                                    <el-option label="建设银行" value="建设银行"></el-option>
                                    <el-option label="中国银行" value="中国银行"></el-option>
                                    <el-option label="招商银行" value="招商银行"></el-option>
                                    <el-option label="工商银行" value="工商银行"></el-option>
                                    <el-option label="中国农业银行" value="中国农业银行"></el-option>
                                    <el-option label="中信银行" value="中信银行"></el-option>
                                    <el-option label="平安银行" value="平安银行"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="首开公积金账号一类卡银行卡号" prop="auFundOpenBankAccount"
                                v-if="form.auFundShenzhenBefore == '否'">
                                <el-input v-model="form.auFundOpenBankAccount" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="社保备注" prop="auSocialSecurityDes">
                                <el-input v-model="form.auSocialSecurityDes" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="其他信息" prop="auDesOther">
                                <el-input v-model="form.auDesOther" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="入职资料提交情况" prop="auInformationEntry">
                                <el-input v-model="form.auInformationEntry" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="离职原因" prop="auLeaveReason">
                                <el-input v-model="form.auLeaveReason" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="离职日期" prop="auLevelDate">
                                <el-date-picker v-model="form.auLevelDate" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="是否发薪" prop="auPayStatus">
                                <el-input v-model="form.auPayStatus" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="社保备注(离职)" prop="auDesLeaveSocialSecurityDes">
                                <el-input v-model="form.auDesLeaveSocialSecurityDes" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="兴趣爱好和自我评价" prop="auEvaluateMime">
                                <el-input v-model="form.auEvaluateMime" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="备注" prop="auDes">
                                <el-input v-model="form.auDes" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item> -->
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="IsDetail" width="70%" top="8vh">
                <div style="max-height: 500px; overflow-y: scroll">
                    <el-descriptions :column="3" border :labelStyle="{
                        color: '#409EFF',
                        textAlign: 'center',
                        width: '14%',
                        fontSize: '12px'
                    }" :contentStyle="{ textAlign: 'center', width: '18%', fontSize: '12px' }">
                        <el-descriptions-item label="姓名">{{ DetailArr.auName }}</el-descriptions-item>
                        <el-descriptions-item label="归属">{{ DetailArr.auBelong }}</el-descriptions-item>
                        <el-descriptions-item label="是否深户" v-if="DetailArr.auBelong === '深圳'">{{ DetailArr.auSh
                            }}</el-descriptions-item>
                        <el-descriptions-item label="所在部门">{{ DetailArr.auDepartment }}</el-descriptions-item>
                        <el-descriptions-item label="职务">{{ DetailArr.auPost }}</el-descriptions-item>
                        <el-descriptions-item label="性别">{{ DetailArr.auSex }}</el-descriptions-item>
                        <el-descriptions-item label="年龄">{{ DetailArr.auAge }}</el-descriptions-item>
                        <el-descriptions-item label="入职时间">{{ DetailArr.auDateEntry }}</el-descriptions-item>
                        <el-descriptions-item label="试用期">{{ DetailArr.auProbationPeriod }}</el-descriptions-item>
                        <el-descriptions-item label="试用期结束时间">{{ DetailArr.auDateRegular }}</el-descriptions-item>
                        <el-descriptions-item label="转正描述">{{ DetailArr.auDateRegularDes }}</el-descriptions-item>
                        <el-descriptions-item label="认证通关/调整部门时间">{{ DetailArr.auDateTransfer }}</el-descriptions-item>
                        <el-descriptions-item label="转岗描述">{{ DetailArr.auDateTransferDes }}</el-descriptions-item>
                        <el-descriptions-item label="状态">{{ DetailArr.auStatus }}</el-descriptions-item>
                        <el-descriptions-item label="面试官">{{ DetailArr.auInterviewer }}</el-descriptions-item>
                        <el-descriptions-item label="合同到期时间">{{ DetailArr.auDateExpirationContract
                        }}</el-descriptions-item>
                        <el-descriptions-item label="籍贯">{{ DetailArr.auOrigin }}</el-descriptions-item>
                        <el-descriptions-item label="政治面貌">{{ DetailArr.auPolitical }}</el-descriptions-item>
                        <el-descriptions-item label="户口所在地">{{ DetailArr.auAddressRegistered }}</el-descriptions-item>
                        <el-descriptions-item label="户口性质">{{ DetailArr.auAddressRegisteredType
                        }}</el-descriptions-item>
                        <el-descriptions-item label="民族">{{ DetailArr.auNation }}</el-descriptions-item>
                        <el-descriptions-item label="婚姻状态">{{ DetailArr.auMarital }}</el-descriptions-item>
                        <el-descriptions-item label="配偶姓名">{{ DetailArr.auMaritalSpouseName }}</el-descriptions-item>
                        <el-descriptions-item label="配偶身份证号">{{ DetailArr.auMaritalSpouseIdcard
                            }}</el-descriptions-item>
                        <el-descriptions-item label="出生年月">{{ DetailArr.auBirth }}</el-descriptions-item>
                        <el-descriptions-item label="身份证号码">{{ DetailArr.auIdcard }}</el-descriptions-item>
                        <el-descriptions-item label="身份证正面(人像面)"> <el-image ref="scrImg" id="scrimg"
                                :src="DetailArr.auIdcardUp" alt="" fit="cover" style="height: 50px;"
                                :preview-src-list="[DetailArr.auIdcardUp]"></el-image></el-descriptions-item>
                        <el-descriptions-item label="身份证反面(国徽面)">
                            <el-image ref="scrImg" id="scrimg" :src="DetailArr.auIdcardDown" alt="" fit="cover"
                                style="height: 50px;" :preview-src-list="[DetailArr.auIdcardDown]"></el-image>
                        </el-descriptions-item>
                        <el-descriptions-item label="发证机关">{{ DetailArr.auIdcardIssuingAuthority
                        }}</el-descriptions-item>
                        <el-descriptions-item label="身份证完整地址">{{ DetailArr.auIdcardAddress }}</el-descriptions-item>
                        <el-descriptions-item label="身份证有效期">{{ DetailArr.auIdcardExpiration }}</el-descriptions-item>
                        <el-descriptions-item label="毕业院校">{{ DetailArr.auSchool }}</el-descriptions-item>
                        <el-descriptions-item label="专业">{{ DetailArr.auMajor }}</el-descriptions-item>
                        <el-descriptions-item label="最高学历">{{ DetailArr.auEducationLevel }}</el-descriptions-item>
                        <el-descriptions-item label="学位证书(图片)">
                            <div v-if="DetailArr.auCertificateEducationXw">
                                <el-image v-for="(item, index) in DetailArr.auCertificateEducationXw.split(',') || []"
                                    ref="scrImg" id="scrimg" :src="item" alt="" fit="cover"
                                    style="width: 100%; height: 50px" :preview-src-list="[item]"></el-image>
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item label="学历证书(图片)">
                            <div v-if="DetailArr.auCertificateEducation">
                                <el-image v-for="(item, index) in DetailArr.auCertificateEducation.split(',') || []"
                                    ref="scrImg" id="scrimg" :src="item" alt="" fit="cover"
                                    style="width: 100%; height: 50px" :preview-src-list="[item]"></el-image>
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item label="学历证书查验证明(图片)">
                            <div v-if="DetailArr.auCertificateEducationCheck">
                                <el-image
                                    v-for="(item, index) in DetailArr.auCertificateEducationCheck.split(',') || []"
                                    ref="scrImg" id="scrimg" :src="item" alt="" fit="cover"
                                    style="width: 100%; height: 50px" :preview-src-list="[item]"></el-image>
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item label="其他证书(图片)">
                            <div v-if="DetailArr.aupCertificatePath">
                                <el-image v-for="(item, index) in DetailArr.aupCertificatePath.split(',') || []"
                                    ref="scrImg" id="scrimg" :src="item" alt="" fit="cover"
                                    style="width: 100%; height: 50px" :preview-src-list="[item]"></el-image>
                            </div>
                        </el-descriptions-item>
                        <!-- <el-descriptions-item label="最高学历">{{ DetailArr.auEducationLevelMax }}</el-descriptions-item> -->
                        <el-descriptions-item label="毕业时间">{{ DetailArr.auGraduationTime }}</el-descriptions-item>
                        <!-- <el-descriptions-item label="浦发银行卡号">{{ DetailArr.auBankCardPf }}</el-descriptions-item> -->
                        <el-descriptions-item label="银行名称">{{ DetailArr.auBankCardOther }}</el-descriptions-item>
                        <el-descriptions-item label="卡号">{{ DetailArr.auBankCardOtherNum }}</el-descriptions-item>
                        <el-descriptions-item label="开户城市">{{ DetailArr.auBankCardOtherOpen }}</el-descriptions-item>
                        <el-descriptions-item label="本人联系方式">{{ DetailArr.auContactMine }}</el-descriptions-item>
                        <el-descriptions-item label="个人邮箱">{{ DetailArr.auEmail }}</el-descriptions-item>
                        <el-descriptions-item label="父亲姓名">{{ DetailArr.auContactDad }}</el-descriptions-item>
                        <el-descriptions-item label="父亲工作单位">{{ DetailArr.auContactDadUnit }}</el-descriptions-item>
                        <el-descriptions-item label="父亲联系方式">{{ DetailArr.auContactDadPhone }}</el-descriptions-item>
                        <el-descriptions-item label="母亲姓名">{{ DetailArr.auContactMom }}</el-descriptions-item>
                        <el-descriptions-item label="母亲工作单位">{{ DetailArr.auContactMomUnit }}</el-descriptions-item>
                        <el-descriptions-item label="母亲联系方式">{{ DetailArr.auContactMomPhone }}</el-descriptions-item>
                        <!-- <el-descriptions-item label="兄弟姐妹姓名">{{ DetailArr.auContactSibling }}</el-descriptions-item>
                        <el-descriptions-item label="兄弟姐妹工作单位">{{ DetailArr.auContactSiblingUnit }}</el-descriptions-item>
                        <el-descriptions-item label="兄弟姐妹联系方式)">{{ DetailArr.auContactSiblingPhone }}</el-descriptions-item> -->
                        <el-descriptions-item label="深圳紧急联系人">{{ DetailArr.auContactEmergency
                        }}</el-descriptions-item><el-descriptions-item label="姓名">{{ DetailArr.auName
                            }}</el-descriptions-item>
                        <!-- <el-descriptions-item label="深圳紧急联系人工作单位">{{ DetailArr.auContactEmergencyUnit
                        }}</el-descriptions-item> -->
                        <el-descriptions-item label="深圳紧急联系人联系方式">{{ DetailArr.auContactEmergencyPhone
                        }}</el-descriptions-item>
                        <el-descriptions-item label="现居住地址">{{ DetailArr.auAddressNow }}</el-descriptions-item>
                        <el-descriptions-item label="社保电脑号">{{ DetailArr.auSocialSecurityNum }}</el-descriptions-item>
                        <el-descriptions-item label="公积金账号">{{ DetailArr.auProvidentFund }}</el-descriptions-item>
                        <el-descriptions-item label="是否缴纳过公积金">{{ DetailArr.auFundShenzhenBefore
                            }}</el-descriptions-item>
                        <el-descriptions-item label="首开公积金账号一类卡银行">{{ DetailArr.auFundOpenBank }}</el-descriptions-item>
                        <el-descriptions-item label="首开公积金账号一类卡银行卡号">{{ DetailArr.auFundOpenBankAccount
                            }}</el-descriptions-item>
                        <el-descriptions-item label="社保备注">{{ DetailArr.auSocialSecurityDes }}</el-descriptions-item>
                        <!-- <el-descriptions-item label="其他信息">{{ DetailArr.auDesOther }}</el-descriptions-item> -->
                        <!-- <el-descriptions-item label="入职资料提交情况">{{ DetailArr.auInformationEntry }}</el-descriptions-item> -->
                        <el-descriptions-item label="离职原因">{{ DetailArr.auLeaveReason }}</el-descriptions-item>
                        <el-descriptions-item label="离职日期">{{ DetailArr.auLevelDate }}</el-descriptions-item>
                        <el-descriptions-item label="是否发薪">{{ DetailArr.auPayStatus }}</el-descriptions-item>
                        <el-descriptions-item label="社保备注(离职)">{{ DetailArr.auDesLeaveSocialSecurityDes
                        }}</el-descriptions-item>
                        <el-descriptions-item label="兴趣爱好和自我评价">{{ DetailArr.auEvaluateMime }}</el-descriptions-item>
                        <el-descriptions-item label="备注">{{ DetailArr.auDes }}</el-descriptions-item>

                    </el-descriptions>

                    <p style="width: 100%;text-align: center;margin: 10px 0;">正在使用的设备</p>
                    <div v-if="DetailArr.ajUserBorrowReturnList" style="width: 100%;">
                        <ve-table ref="vetable" v-if="DetailArr.ajUserBorrowReturnList.length > 0" :columns="columnHis"
                            :table-data="DetailArr.ajUserBorrowReturnList" :max-height="400" :border-x="true"
                            :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                            style="width: 100%;" />
                    </div>

                </div>
            </el-dialog>
            <!-- 添加关联 -->
            <el-dialog title="关联资产" :visible.sync="Related" width="30%" :before-close="handleClose">
                <div style="width: 70%; margin: 10px auto;">
                    <!-- <el-select v-model="form.aaId" placeholder="请选择" @change="$forceUpdate()">
                        <el-option v-for="item in aaTypearr || []" :label="item.aaName" :value="item.aaId" :key="item.aaId">
                        </el-option>
                    </el-select> -->
                </div>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="Related = false">取 消</el-button>
                    <el-button type="primary" @click="sureRelated">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 筛选 -->
            <el-dialog title="更多搜索" :visible.sync="IsSerch" width="70%" top="8vh" :close-on-click-modal="false">
                <div style=" width: 98%; height:400px;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formDatas" :model="formDatas" label-position="left" label-width="130px"
                            @submit.native.prevent>
                            <div style="width: 50%; display: inline-block">
                                <el-form-item label="姓名">
                                    <el-input v-model="formDatas.auName" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="归属">
                                    <el-input v-model="formDatas.auBelong" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="部门">
                                    <el-input v-model="formDatas.auDepartment" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="职务">
                                    <el-input v-model="formDatas.auPost" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="性别">
                                    <el-select v-model="formDatas.auSex" clearable @change="partserch" placeholder="请选择"
                                        style="width: 130px">
                                        <el-option label="男" value="男" key="1"></el-option>
                                        <el-option label="女" value="女" key="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="身份证号码">
                                    <el-input v-model="formDatas.auIdcard" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="年龄">
                                    <el-input type="number" v-model="formDatas.auAgeStart" style="width: 40%;"
                                        placeholder="请输入"></el-input>
                                    <span style="margin: 0 10px;">-</span>
                                    <el-input type="number" v-model="formDatas.auAgeEnd" style="width: 40%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="入职时间">
                                    <el-date-picker v-model="formDatas.auDateEntryStart" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                    <span style="margin: 0 10px;">-</span>
                                    <el-date-picker v-model="formDatas.auDateEntryEnd" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="状态">
                                    <el-input v-model="formDatas.auStatus" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="面试官">
                                    <el-input v-model="formDatas.auInterviewer" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>

                            </div>
                            <div style="width: 50%; display: inline-block">
                                <el-form-item label="户口性质">
                                    <el-select v-model="formDatas.auAddressRegisteredType" placeholder="请选择">
                                        <el-option v-for="item in auAddressRegisteredTypeArr || []" :label="item.key"
                                            :value="item.value" :key="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="身份证有效日期">
                                    <el-date-picker v-model="formDatas.auIdcardExpirationStart" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                    <span style="margin: 0 10px;">-</span>
                                    <el-date-picker v-model="formDatas.auIdcardExpirationEnd" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="毕业院校">
                                    <el-input v-model="formDatas.auSchool" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="专业">
                                    <el-input v-model="formDatas.auSchool" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="最高学历">
                                    <el-input v-model="formDatas.auSchool" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="毕业时间">
                                    <el-date-picker v-model="formDatas.auGraduationTimeStart" type="month"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                    <span style="margin: 0 10px;">-</span>
                                    <el-date-picker v-model="formDatas.auGraduationTimeEnd" type="month"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                </el-form-item>
                                <!-- <el-form-item label="最高学历">
                                    <el-input v-model="formDatas.auEducationLevelMax" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item> -->
                                <el-form-item label="本人联系方式">
                                    <el-input v-model="formDatas.auContactMine" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="社保电脑号">
                                    <el-input v-model="formDatas.auSocialSecurityNum" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="公积金账号">
                                    <el-input v-model="formDatas.auProvidentFund" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <!-- <el-form-item label="入职资料提交情况">
                                    <el-input v-model="formDatas.auInformationEntry" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item> -->
                                <el-form-item label="审核状态">
                                    <el-select v-model="formDatas.afStatus" clearable placeholder="请选择"
                                        style="width: 130px">
                                        <el-option label="否" :value="1" key="1"></el-option>
                                        <el-option label="是" :value="2" key="2"></el-option>

                                    </el-select>
                                </el-form-item>
                            </div>

                        </el-form>

                    </div>
                </div>
                <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                    <el-button type="primary" @click="partserch(), IsSerch = false"
                        style="margin-left: 100px">立即搜索</el-button>
                    <el-button @click="closeSizer()" style="margin-left: 200px">取消</el-button>
                </div>

            </el-dialog>
            <!-- 批量导入 -->
            <el-dialog title="批量导入" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
                style="margin-left: 200px;">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size=" medium" type="danger">点击上传</el-button>

                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('http://192.168.6.109/data120/assets/user.xlsx', '花名册模板')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div style="margin: 10px;font-size: 18px;" v-if="bulkData.length != 0">
                    <span style="color: #0080FF;">一共{{ importData.numAll }}条;</span>
                    <span style="color: #0E9A00;margin-left: 5px;">成功{{ importData.numSuccess }}条;</span>
                    <span style="color: red;margin-left: 5px;">失败{{ importData.numFail }}条</span>
                    <span style="color: #E6A23C;margin-left: 5px;">信息不完整{{ importData.numUnWhole }}条</span>
                </div>
                <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                    <!-- <el-button @click="bulkImportClose">取 消</el-button> -->
                    <el-button type="success" @click="bulkImportClick">确定导入</el-button>
                </div>
            </el-dialog>
            <!-- 编辑日期 -->
            <el-dialog title="编辑" :visible.sync="dbtrue" width="50%" top="8vh">
                <el-select v-model="dateUpdata" placeholder="请选择" v-if="TypeId == 2">
                    <el-option v-for="item in EditArr || []" :label="item.key" :value="item.value" :key="item.id">
                    </el-option>
                </el-select>
                <el-select v-if="TypeId == 3" v-model="dateUpdata" placeholder="请选择">
                    <el-option v-for="item in auNationArr || []" :label="item.snName" :value="item.snName"
                        :key="item.snId">
                    </el-option>
                </el-select>

                <el-date-picker v-if="TypeId == 1" v-model="dateUpdata" type="date" value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
                <span slot="footer" class="dialog-footer">
                    <!-- <el-button @click="CloseBreak">取 消</el-button> -->
                    <el-button type="primary" @click="sureDate">确 定</el-button>
                </span>
            </el-dialog>

            <!-- 上传图片 -->
            <el-dialog title="上传图片" :visible.sync="IsImg" width="50%" top="8vh">

                <div v-if="type == 1">
                    <p>上传身份证正面(人像面)</p>
                    <my-uploadTwo ref="upcard2" @fileChange="auIdcardUpfileChangeTwo" :filearr="UpfileList"
                        :limit="limit" @removeAfter="UpremoveAfter" apiType="cardUp" style="margin: 10px 5px 5px;">
                    </my-uploadTwo>
                    <div>
                        <p>上传身份证反面(国徽面)</p>
                        <my-uploadTwo ref="Downcard2" @fileChange="auIdcardDownfileChange" :filearr="DownfileList"
                            :limit="limit" apiType="cardDown" style="margin: 10px 5px 5px;">
                        </my-uploadTwo>
                    </div>
                </div>

                <div v-if="type == 2">
                    <p>上传学历证书</p>
                    <my-uploadTwo ref="xlupload2" @fileChange="XlfileChange" :filearr="xlfileList" :limit="limit"
                        style="margin: 10px 5px 5px;">
                    </my-uploadTwo>
                    <div>
                        <p>上传学历查验证明</p>
                        <my-uploadTwo ref="Cyupload2" @fileChange="CyfileChange" :filearr="CyfileList" :limit="limit"
                            style="margin: 10px 5px 5px;">
                        </my-uploadTwo>
                    </div>
                </div>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="CloseImg">取 消</el-button>
                    <el-button type="primary" @click="sureImg">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 模板编辑 -->
            <el-dialog title="word模板" :visible.sync="IsWord" width="50%" top="8vh">
                <div style="width: 100%" v-if="wordtypenum == 1">
                    <ve-table ref="wordtable" v-if="wordData" :columns="wordcolumns" :table-data="wordData"
                        :max-height="600" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" row-key-field-name="auwId" style="width: 100%"
                        :editOption="editOption2" />
                    <div v-show="wordData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div v-if="wordtypenum == 2">
                    <el-radio-group v-model="wordType" style="display:block;text-align: center;">
                        <el-radio-button v-for="(item, index) in wordData" :key="index" :label="item.auwId">{{
                            item.auwTitle
                        }}</el-radio-button>

                    </el-radio-group>

                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="Closeword">取 消</el-button>
                    <el-button type="primary" @click="sureword">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 离职 -->
            <el-dialog title="用户离职" :visible.sync="IsLevel" width="50%" top="8vh">
                <div style="width: 100%; height: 100%; padding: 5%">
                    <el-form ref="formDatas" :model="formLevel" label-position="left" label-width="130px"
                        @submit.native.prevent>

                        <el-form-item label="离职原因">
                            <el-input v-model="formLevel.auLeaveReason" style="width: 80%;"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="离职日期">

                            <el-date-picker v-model="formLevel.auLevelDate" type="date" value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="是否发薪">
                            <el-input v-model="formLevel.auPayStatus" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="社保备注">
                            <el-input v-model="formLevel.auDesLeaveSocialSecurityDes" style="width: 80%;"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="CloseLevel">取 消</el-button>
                    <el-button type="primary" @click="sureLevel">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 编辑资料 -->
            <el-dialog title="编辑资料" :visible.sync="IsConact" width="50%" top="8vh">
                <div style="width: 100%; height: 100%; padding: 5%">
                    <el-form ref="formConact" :model="form" label-position="left" label-width="130px"
                        @submit.native.prevent>
                        <div v-if="conactType == 1">
                            <div style="width: 90%;margin: 15px auto;text-align: center;">银行卡信息</div>
                            <!-- <el-form-item label="浦发银行卡号">
                                <el-input v-model="form.auBankCardPf" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item> -->
                            <el-form-item label="其他银行">
                                <el-input v-model="form.auBankCardOther" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="卡号">
                                <el-input v-model="form.auBankCardOtherNum" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户行">
                                <el-input v-model="form.auBankCardOtherOpen" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                        <div v-if="conactType == 2">
                            <div style="width: 90%;margin: 15px auto;text-align: center;">家庭信息</div>
                            <el-form-item label="父亲姓名">
                                <el-input v-model="form.auContactDad" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="父亲工作单位">
                                <el-input v-model="form.auContactDadUnit" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="父亲联系方式">
                                <el-input v-model="form.auContactDadPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="母亲姓名">
                                <el-input v-model="form.auContactMom" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="母亲工作单位">
                                <el-input v-model="form.auContactMomUnit" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="母亲联系方式">
                                <el-input v-model="form.auContactMomPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="兄弟姐妹姓名">
                                <el-input v-model="form.auContactSibling" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="兄弟姐妹工作单位">
                                <el-input v-model="form.auContactSiblingUnit" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="兄弟姐妹联系方式">
                                <el-input v-model="form.auContactSiblingPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item> -->
                        </div>
                        <div v-if="conactType == 3">
                            <div style="width: 90%;margin: 15px auto;text-align: center;">同城紧急联系人信息</div>
                            <el-form-item label="同城紧急联系人姓名">
                                <el-input v-model="form.auContactEmergency" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="同城紧急联系人联系方式">
                                <el-input v-model="form.auContactEmergencyPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>

                        </div>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="CloseConact">取 消</el-button>
                    <el-button type="primary" @click="sureConact">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 转岗 -->
            <el-dialog title="转岗记录" :visible.sync="transferShow" width="80%" top="8vh" @beforeClose="transferShowClose">
                <div style="width: 100%;margin: 10px;">
                    <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                        <el-button type="success" size="small" style="margin-right: 20px"
                            @click="AddtransferClick">新增转岗</el-button>

                        <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                    </el-row>
                </div>
                <el-card>
                    <ve-table ref="tftable" v-if="transferData" :columns="columnTransfer" :table-data="transferData"
                        :max-height="500" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="transferData.length == 0" class="empty-data">暂无数据</div>
                </el-card>
                <el-dialog append-to-body :title="editTf ? '编辑转岗' : '新增转岗'" :visible.sync="AddtransferShow" width="60%"
                    top="8vh">
                    <el-form ref="formTf" :model="formTf" label-position="left" label-width="130px"
                        @submit.native.prevent>
                        <el-form-item label="转到岗位">
                            <el-input v-model="formTf.auprNameTo" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="转到部门">
                            <el-input v-model="formTf.auprNameDtTo" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="转岗日期">
                            <el-date-picker v-model="formTf.auprDate" type="date" value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <div style="display: flex;width: 70%;margin-left: 25%;justify-content: space-around;"
                            class="dialog-footer">
                            <el-button @click="transferClose">取 消</el-button>
                            <el-button type="primary" @click="transferSure">确 定</el-button>
                        </div>
                    </el-form>
                </el-dialog>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="transferShowClose">取 消</el-button>
                </span>
            </el-dialog>
            <!-- 批量导入 -->
            <el-dialog title="同步更新" :visible.sync="Isupdata" width="70%" :before-close="IsupdataClose"
                style="margin-left: 200px;z-index: 99;">
                <div>
                    <ve-table :columns="columnsupdata" :table-data="updataData" :max-height="550" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="updataData.length == 0" class="empty-data">{{ updatamsg }}</div>
                </div>

            </el-dialog>
            <!-- 批量修改部门  -->
            <el-dialog title="编辑部门" :visible.sync="Isdepartment" width="60%" :before-close="IsdepartmentClose"
                style="margin-left: 200px;z-index: 99;">
                <el-cascader v-model="auDepartment" :options="auDepartmentArr" :show-all-levels="false"
                    :props="{ checkStrictly: true }"></el-cascader>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="IsdepartmentClose">取 消</el-button>
                    <el-button type="primary" @click="sureIsdepartment">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 借还记录 -->
            <el-dialog title="设备领/借用申请记录" :visible.sync="IsHistory" width="70%" top="8vh">
                <ve-table ref="vetable" v-if="HistoryData" :columns="columnHis" :table-data="HistoryData"
                    :max-height="500" :border-x="true" :border-y="true" :scrollWidth="10"
                    :cell-style-option="cellStyleOption" style="width: 100%" />
                <div v-show="HistoryData.length == 0" class="empty-data">暂无数据</div>
                <p style="width: 100%;margin:15px auto;text-align: center;font-size: 20px;">
                    请确认本周入职人员设备领借是否正确,如无误,请点击确认
                </p>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="sureSheBei">确认无误</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import {
    addAjUserPostRecord, getAjUserPostRecordList, updateAjUserPostRecord, getAssetsAjUserSyn,
    getAjUserListUnCheck, addAjUser, updateAjUser, deleteAjUser, updateAjUserAssetsConfirm,
    getSysNationList, exportAjUserWord, uploadAjUser, getAjUserDetails, updateAjUserDepartments,
    updateAjFittingsAssetsUnbinding, getAjUserBorrowApplyList, updateAjUserCheck,
    uploadImportAjUser, exportAjUser, getAjUserBorrowReturnList, updateAjUserIdCard, updateAjUserCertificate,
    getSysRegionList, getAjUserWordList, updateAjUserWord, updateAjUserLeave, updateAjUserBank, updateAjUserContact,
    getAjUserItem, getAjUserBelongList,

} from "../../api/api";
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
export default {
    name: "",
    components: {},
    data() {
        return {
            theAuAssetsId: '',
            theUser: localStorage.getItem("iuName"),
            columnHis: [

                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "aubaBorrowType",
                    key: "aubaBorrowType",
                    title: "资产类型",
                    fixed: 'left',
                    align: "center",
                    width: 80,
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"

                                >
                                    {row.aubaBorrowType == 1 ? '领用' : '借用 '}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "aubaType",
                    key: "aubaType",
                    title: "物品类型",
                    align: "center",
                    width: 80,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"

                                >
                                    {row.aubaType == 1 ? '资产' : row.aubaType == 2 ? '配件 ' : row.aubaType == 3 ? '耗材 ' : '手机卡'}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "aubaThisName",
                    key: "aubaThisName",
                    title: "借用物品",
                    align: "center",
                    fixed: 'left',
                    width: 80,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.getDetail(row.aubaId)}
                                >
                                    {row.aubaThisName}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "aubaThisNumber",
                    key: "aubaThisNumber",
                    title: "资产编码",
                    align: "center",
                    width: 150,
                },

                {
                    field: "aubaThisNum",
                    key: "aubaThisNum",
                    title: "数量",
                    align: "center",
                    width: 80,
                },
                {
                    field: "aubaReturnPlanDate",
                    key: "aubaReturnPlanDate",
                    title: "计划归还时间",
                    align: "center",
                    width: 150,
                    // fixed:'left',

                },
                {
                    field: "auName",
                    key: "auName",
                    title: "申请人",
                    align: "center",
                    width: 80,
                },
                {
                    field: "aubaThisDes",
                    key: "aubaThisDes",
                    title: "备注",
                    align: "center",
                    width: 180,
                },
                {
                    field: "aubaImages",
                    key: "aubaImages",
                    title: "资产图片",
                    align: "center",
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aubaImages ? <el-image ref="scrImg" id="scrimg" src={row.aubaImages.split(',')[0]} alt="" fit="fill" style="width: 50px;height: 50px;"
                                        previewSrcList={row.aubaImages.split(',')}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },
                },
                {
                    field: "aubaSign",
                    key: "aubaSign",
                    title: "签名图片",
                    align: "center",
                    width: 120,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aubaSign ? <el-image ref="scrImg" id="scrimg" src={row.aubaSign} alt="" fit="fill" style="width: 50px;height: 50px;"
                                        previewSrcList={[row.aubaSign]}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },

                },
                {
                    field: "aubaSignScreenshot",
                    key: "aubaSignScreenshot",
                    title: "完整图片",
                    align: "center",
                    width: 120,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aubaSignScreenshot ? <el-image ref="scrImg" id="scrimg" src={row.aubaSignScreenshot} alt="" fit="fill" style="width: 50px;height: 50px;"
                                        previewSrcList={[row.aubaSignScreenshot]}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },

                },
                {
                    field: "aubaCheckDes",
                    key: "aubaCheckDes",
                    title: "审核备注",
                    align: "center",
                    width: 180,
                },
                {
                    field: "aubaStatus",
                    key: "aubaStatus",
                    title: "审核",
                    width: 200,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aubaStatus == 1 ? <el-tag size="mini">待审核</el-tag> : row.aubaStatus == 2 ? <el-tag type="success" size="mini">通过</el-tag> : row.aubaStatus == 3 ? <el-tag type="danger" size="mini">拒绝</el-tag> : <el-tag type="success" size="mini">已归还</el-tag>
                                }
                            </span>
                        );
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },

            ],
            HistoryData: [],

            iuId: '',
            aubName_arr: [],
            Isdepartment: false,
            auDepartmentArr: [],
            auDepartment: '',
            updatamsg: '暂无数据',
            updataData: [],
            columnsupdata: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "synStatus",
                    key: "synStatus",
                    title: "状态",
                    width: 150,
                    align: "center",
                    fixed: 'left',
                },
                {
                    field: "synDes",
                    key: "synDes",
                    title: "状态备注",
                    width: 150,
                    align: "center",


                },
                {
                    field: "auName",
                    key: "auName",
                    title: "姓名",
                    align: "center",

                    width: 100,

                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"

                                >
                                    {row.auName}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "auBelong",
                    key: "auBelong",
                    title: "归属",
                    width: 100,
                    align: "center",

                },
                {
                    field: "auSh",
                    key: "auSh",
                    title: "是否深户",
                    width: 90,
                    align: "center",

                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "所在部门",
                    width: 100,
                    align: "center",

                },
                {
                    field: "auPost",
                    key: "auPost",
                    title: "职务",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auSex",
                    key: "auSex",
                    title: "性别",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auAge",
                    key: "auAge",
                    title: "年龄",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auDateEntry",
                    key: "auDateEntry",
                    title: "入职时间",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;">{row.auDateEntry}</div>
                            </span>
                        );
                    },
                },
                {
                    field: "auProbationPeriod",
                    key: "auProbationPeriod",
                    title: "试用期(月)",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auDateRegular",
                    key: "auDateRegular",
                    title: "试用期结束时间",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.auDateRegular}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auDateTransfer",
                    key: "auDateTransfer",
                    title: "认证通关/调整部门时间",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.auDateTransfer}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auStatus",
                    key: "auStatus",
                    title: "状态",
                    align: "center",
                    width: 100,


                },

                {
                    field: "auInterviewer",
                    key: "auInterviewer",
                    title: "面试官",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auDateExpirationContract",
                    key: "auDateExpirationContract",
                    title: "合同到期时间",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;;" >{row.auDateExpirationContract}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auOrigin",
                    key: "auOrigin",
                    title: "籍贯",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auPolitical",
                    key: "auPolitical",
                    title: "政治面貌",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auAddressRegistered",
                    key: "auAddressRegistered",
                    title: "户口所在地",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auAddressRegisteredType",
                    key: "auAddressRegisteredType",
                    title: "户口性质",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auNation",
                    key: "auNation",
                    title: "民族",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auBirth",
                    key: "auBirth",
                    title: "出生年月",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.auBirth}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auIdcard",
                    key: "auIdcard",
                    title: "身份证号码",
                    align: "center",
                    width: 120,


                },

                {
                    field: "auIdcardIssuingAuthority",
                    key: "auIdcardIssuingAuthority",
                    title: "发证机关",
                    align: "center",
                    width: 100,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auIdcardAddress",
                    key: "auIdcardAddress",
                    title: "身份证完整地址",
                    align: "center",
                    width: 150,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auIdcardExpiration",
                    key: "auIdcardExpiration",
                    title: "身份证有效期",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.auIdcardExpiration}</div>
                            </span>
                        );
                    },
                },
                {
                    field: "auSchool",
                    key: "auSchool",
                    title: "毕业院校",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auMajor",
                    key: "auMajor",
                    title: "专业",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auEducationLevel",
                    key: "auEducationLevel",
                    title: "最高学历",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auGraduationTime",
                    key: "auGraduationTime",
                    title: "毕业时间",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.auGraduationTime}</div>
                            </span>
                        );
                    },
                },

                // {
                //     field: "auEducationLevelMax",
                //     key: "auEducationLevelMax",
                //     title: "最高学历",
                //     align: "center",
                //     width: 100,


                // },
                // {
                //     field: "auBankCardPf",
                //     key: "auBankCardPf",
                //     title: "浦发银行卡号",
                //     align: "center",
                //     width: 120,


                // },
                {
                    field: "auBankCardOther",
                    key: "auBankCardOther",
                    title: "其他银行",
                    align: "center",
                    width: 120,


                },
                {
                    field: "auBankCardOtherNum",
                    key: "auBankCardOtherNum",
                    title: "其他银行卡号",
                    align: "center",
                    width: 120,


                },
                {
                    field: "auBankCardOtherOpen",
                    key: "auBankCardOtherOpen",
                    title: "其他银行开户行",
                    align: "center",
                    width: 100,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auContactMine",
                    key: "auContactMine",
                    title: "本人联系方式",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auEmail",
                    key: "auEmail",
                    title: "个人邮箱",
                    align: "center",
                    width: 130,


                },
                {
                    field: "auContactDad",
                    key: "auContactDad",
                    title: "父亲姓名",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auContactDadUnit",
                    key: "auContactDadUnit",
                    title: "父亲工作单位",
                    align: "center",
                    width: 150,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auContactDadPhone",
                    key: "auContactDadPhone",
                    title: "父亲联系方式",
                    align: "center",
                    width: 120,


                },
                {
                    field: "auContactMom",
                    key: "auContactMom",
                    title: "母亲姓名",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auContactMomUnit",
                    key: "auContactMomUnit",
                    title: "母亲工作单位",
                    align: "center",
                    width: 150,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auContactMomPhone",
                    key: "auContactMomPhone",
                    title: "母亲联系方式",
                    align: "center",
                    width: 120,


                },
                // {
                //     field: "auContactSibling",
                //     key: "auContactSibling",
                //     title: "兄弟姐妹姓名",
                //     align: "center",
                //     width: 100,


                // },
                // {
                //     field: "auContactSiblingUnit",
                //     key: "auContactSiblingUnit",
                //     title: "兄弟姐妹工作单位",
                //     align: "center",
                //     width: 150,

                //     ellipsis: {
                //         showTitle: true,
                //         lineClamp: 2,
                //     },
                // },
                // {
                //     field: "auContactSiblingPhone",
                //     key: "auContactSiblingPhone",
                //     title: "兄弟姐妹联系方式",
                //     align: "center",
                //     width: 120,


                // },
                {
                    field: "auContactEmergency",
                    key: "auContactEmergency",
                    title: "深圳紧急联系人姓名",
                    align: "center",
                    width: 150,


                },
                {
                    field: "auContactEmergencyUnit",
                    key: "auContactEmergencyUnit",
                    title: "深圳紧急联系人工作单位",
                    align: "center",
                    width: 180,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auContactEmergencyPhone",
                    key: "auContactEmergencyPhone",
                    title: "深圳紧急联系人联系方式",
                    align: "center",
                    width: 180,


                },
                {
                    field: "auAddressNow",
                    key: "auAddressNow",
                    title: "现居住地址",
                    align: "center",
                    width: 150,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auSocialSecurityNum",
                    key: "auSocialSecurityNum",
                    title: "社保电脑号",
                    align: "center",
                    width: 130,


                },
                {
                    field: "auProvidentFund",
                    key: "auProvidentFund",
                    title: "公积金账号",
                    align: "center",
                    width: 130,


                },
                {
                    field: "auSocialSecurityDes",
                    key: "auSocialSecurityDes",
                    title: "社保备注",
                    align: "center",
                    width: 120,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auDesOther",
                    key: "auDesOther",
                    title: "其他信息",
                    align: "center",
                    width: 100,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auInformationEntry",
                    key: "auInformationEntry",
                    title: "入职资料提交情况",
                    align: "center",
                    width: 130,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auLeaveReason",
                    key: "auLeaveReason",
                    title: "离职原因",
                    align: "center",
                    width: 120,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auLevelDate",
                    key: "auLevelDate",
                    title: "离职日期",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.auLevelDate}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auPayStatus",
                    key: "auPayStatus",
                    title: "是否发薪",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auDesLeaveSocialSecurityDes",
                    key: "auDesLeaveSocialSecurityDes",
                    title: "社保备注(离职)",
                    align: "center",
                    width: 100,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auEvaluateMime",
                    key: "auEvaluateMime",
                    title: "兴趣爱好和自我评价",
                    align: "center",
                    width: 150,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },



                {
                    field: "afDes",
                    key: "afDes",
                    title: "备注",
                    align: "center",

                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },



            ],
            Isupdata: false,
            editTf: false,
            formTf: {
                auprId: '',
                auprNameTo: '',
                auprNameDtTo: '',
                auprDate: '',
            },
            AddtransferShow: false,
            transferData: [],
            columnTransfer: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "auprName",
                    key: "auprName",
                    title: "原岗位",
                    align: "center",
                    width: 160
                },
                {
                    field: "auprNameTo",
                    key: "auprNameTo",
                    title: "转到岗位",
                    align: "center",
                    width: 160
                },
                {
                    field: "auprNameDt",
                    key: "auprNameDt",
                    title: "原部门",
                    align: "center",
                    width: 160
                },
                {
                    field: "auprNameDtTo",
                    key: "auprNameDtTo",
                    title: "转到部门",
                    align: "center",
                    width: 160
                },
                {
                    field: "auprDate",
                    key: "auprDate",
                    title: "转岗日期",
                    align: "center",
                    width: 160
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 250,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.transferEdit(row)}
                                >
                                    编辑
                                </el-button>

                            </span>
                        );
                    },
                },
            ],
            transferShow: false,
            IsConact: false,
            conactType: 0,
            formLevel: {

            },
            IsLevel: false,
            wordType: '',
            wordtypenum: 1,
            wordData: [],
            IsWord: false,
            bankShow: '',
            familyShow: [],
            education: '全日制',
            auAddressNowPL: '请选择地区',
            auAddressNowvalue: '',
            auAddressNowDetail: '',
            auOriginPL: '请选择地区',
            auOriginvalue: '',
            props: {
                lazy: true,
                lazyLoad(node, resolve) {
                    //console.log(node);
                    const { level } = node;
                    getSysRegionList({ srSuperiorCode: node.value }).then(res => {
                        const nodes = res.data.map(item => ({
                            value: item.srCode,
                            label: item.srName,
                            leaf: level >= 2
                        }))
                        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                        resolve(nodes);
                    })

                }
            },
            auOriginArr: [],
            type: '',
            IsImg: false,
            TypeId: 0,
            EditArr: [],
            wordcolumns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "auwTitle",
                    key: "auwTitle",
                    title: "标题",
                    align: "center",
                    fixed: 'left',
                    width: 160,
                    edit: true,
                },
                // {
                //     field: "auwName",
                //     key: "auwName",
                //     title: "模板名称",
                //     align: "center",
                //     fixed: 'left',
                //     width: 160,
                // },
                // { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
            ],

            HistoryData: [],
            IsHistory: false,
            sitId: '',
            TemstrongArr: [],
            importData: {},
            bulkData: [],
            bulkDataCopy: [],

            bulkImport: false,

            columnsImport: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "status",
                    key: "status",
                    title: "状态",
                    width: 150,
                    align: "center",
                    fixed: 'left',
                    filter: {
                        filterList: [
                            { value: 0, label: '成功', selected: false },
                            { value: 1, label: '失败', selected: false },
                            { value: 3, label: '信息不完整', selected: false }
                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            //console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            this.searchByNameField(labels, 'status');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameField([]);
                        },
                        // max height
                        maxHeight: 120,

                    },
                },
                {
                    field: "statusMsg",
                    key: "statusMsg",
                    title: "状态备注",
                    width: 150,
                    align: "center",


                },
                {
                    field: "auName",
                    key: "auName",
                    title: "姓名",
                    align: "center",

                    width: 100,

                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"

                                >
                                    {row.auName}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "auBelong",
                    key: "auBelong",
                    title: "归属",
                    width: 100,
                    align: "center",

                },
                {
                    field: "auSh",
                    key: "auSh",
                    title: "是否深户",
                    width: 90,
                    align: "center",

                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "所在部门",
                    width: 100,
                    align: "center",

                },
                {
                    field: "auPost",
                    key: "auPost",
                    title: "职务",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auSex",
                    key: "auSex",
                    title: "性别",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auAge",
                    key: "auAge",
                    title: "年龄",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auDateEntry",
                    key: "auDateEntry",
                    title: "入职时间",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;">{row.auDateEntry}</div>
                            </span>
                        );
                    },
                },
                {
                    field: "auProbationPeriod",
                    key: "auProbationPeriod",
                    title: "试用期(月)",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auDateRegular",
                    key: "auDateRegular",
                    title: "试用期结束时间",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.auDateRegular}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auDateTransfer",
                    key: "auDateTransfer",
                    title: "认证通关/调整部门时间",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.auDateTransfer}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auStatus",
                    key: "auStatus",
                    title: "状态",
                    align: "center",
                    width: 100,


                },

                {
                    field: "auInterviewer",
                    key: "auInterviewer",
                    title: "面试官",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auDateExpirationContract",
                    key: "auDateExpirationContract",
                    title: "合同到期时间",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;;" >{row.auDateExpirationContract}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auOrigin",
                    key: "auOrigin",
                    title: "籍贯",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auPolitical",
                    key: "auPolitical",
                    title: "政治面貌",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auAddressRegistered",
                    key: "auAddressRegistered",
                    title: "户口所在地",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auAddressRegisteredType",
                    key: "auAddressRegisteredType",
                    title: "户口性质",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auNation",
                    key: "auNation",
                    title: "民族",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auBirth",
                    key: "auBirth",
                    title: "出生年月",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.auBirth}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auIdcard",
                    key: "auIdcard",
                    title: "身份证号码",
                    align: "center",
                    width: 120,


                },

                {
                    field: "auIdcardIssuingAuthority",
                    key: "auIdcardIssuingAuthority",
                    title: "发证机关",
                    align: "center",
                    width: 100,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auIdcardAddress",
                    key: "auIdcardAddress",
                    title: "身份证完整地址",
                    align: "center",
                    width: 150,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auIdcardExpiration",
                    key: "auIdcardExpiration",
                    title: "身份证有效期",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.auIdcardExpiration}</div>
                            </span>
                        );
                    },
                },
                {
                    field: "auSchool",
                    key: "auSchool",
                    title: "毕业院校",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auMajor",
                    key: "auMajor",
                    title: "专业",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auEducationLevel",
                    key: "auEducationLevel",
                    title: "最高学历",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auGraduationTime",
                    key: "auGraduationTime",
                    title: "毕业时间",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.auGraduationTime}</div>
                            </span>
                        );
                    },
                },

                // {
                //     field: "auEducationLevelMax",
                //     key: "auEducationLevelMax",
                //     title: "最高学历",
                //     align: "center",
                //     width: 100,


                // },
                // {
                //     field: "auBankCardPf",
                //     key: "auBankCardPf",
                //     title: "浦发银行卡号",
                //     align: "center",
                //     width: 120,


                // },
                {
                    field: "auBankCardOther",
                    key: "auBankCardOther",
                    title: "其他银行",
                    align: "center",
                    width: 120,


                },
                {
                    field: "auBankCardOtherNum",
                    key: "auBankCardOtherNum",
                    title: "其他银行卡号",
                    align: "center",
                    width: 120,


                },
                {
                    field: "auBankCardOtherOpen",
                    key: "auBankCardOtherOpen",
                    title: "其他银行开户行",
                    align: "center",
                    width: 100,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auContactMine",
                    key: "auContactMine",
                    title: "本人联系方式",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auEmail",
                    key: "auEmail",
                    title: "个人邮箱",
                    align: "center",
                    width: 130,


                },
                {
                    field: "auContactDad",
                    key: "auContactDad",
                    title: "父亲姓名",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auContactDadUnit",
                    key: "auContactDadUnit",
                    title: "父亲工作单位",
                    align: "center",
                    width: 150,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auContactDadPhone",
                    key: "auContactDadPhone",
                    title: "父亲联系方式",
                    align: "center",
                    width: 120,


                },
                {
                    field: "auContactMom",
                    key: "auContactMom",
                    title: "母亲姓名",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auContactMomUnit",
                    key: "auContactMomUnit",
                    title: "母亲工作单位",
                    align: "center",
                    width: 150,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auContactMomPhone",
                    key: "auContactMomPhone",
                    title: "母亲联系方式",
                    align: "center",
                    width: 120,


                },
                // {
                //     field: "auContactSibling",
                //     key: "auContactSibling",
                //     title: "兄弟姐妹姓名",
                //     align: "center",
                //     width: 100,


                // },
                // {
                //     field: "auContactSiblingUnit",
                //     key: "auContactSiblingUnit",
                //     title: "兄弟姐妹工作单位",
                //     align: "center",
                //     width: 150,

                //     ellipsis: {
                //         showTitle: true,
                //         lineClamp: 2,
                //     },
                // },
                // {
                //     field: "auContactSiblingPhone",
                //     key: "auContactSiblingPhone",
                //     title: "兄弟姐妹联系方式",
                //     align: "center",
                //     width: 120,


                // },
                {
                    field: "auContactEmergency",
                    key: "auContactEmergency",
                    title: "深圳紧急联系人姓名",
                    align: "center",
                    width: 150,


                },
                {
                    field: "auContactEmergencyUnit",
                    key: "auContactEmergencyUnit",
                    title: "深圳紧急联系人工作单位",
                    align: "center",
                    width: 180,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auContactEmergencyPhone",
                    key: "auContactEmergencyPhone",
                    title: "深圳紧急联系人联系方式",
                    align: "center",
                    width: 180,


                },
                {
                    field: "auAddressNow",
                    key: "auAddressNow",
                    title: "现居住地址",
                    align: "center",
                    width: 150,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auSocialSecurityNum",
                    key: "auSocialSecurityNum",
                    title: "社保电脑号",
                    align: "center",
                    width: 130,


                },
                {
                    field: "auProvidentFund",
                    key: "auProvidentFund",
                    title: "公积金账号",
                    align: "center",
                    width: 130,


                },
                {
                    field: "auSocialSecurityDes",
                    key: "auSocialSecurityDes",
                    title: "社保备注",
                    align: "center",
                    width: 120,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auDesOther",
                    key: "auDesOther",
                    title: "其他信息",
                    align: "center",
                    width: 100,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auInformationEntry",
                    key: "auInformationEntry",
                    title: "入职资料提交情况",
                    align: "center",
                    width: 130,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auLeaveReason",
                    key: "auLeaveReason",
                    title: "离职原因",
                    align: "center",
                    width: 120,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auLevelDate",
                    key: "auLevelDate",
                    title: "离职日期",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.auLevelDate}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auPayStatus",
                    key: "auPayStatus",
                    title: "是否发薪",
                    align: "center",
                    width: 100,


                },
                {
                    field: "auDesLeaveSocialSecurityDes",
                    key: "auDesLeaveSocialSecurityDes",
                    title: "社保备注(离职)",
                    align: "center",
                    width: 100,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auEvaluateMime",
                    key: "auEvaluateMime",
                    title: "兴趣爱好和自我评价",
                    align: "center",
                    width: 150,

                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },



                {
                    field: "afDes",
                    key: "afDes",
                    title: "备注",
                    align: "center",

                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },



            ], //表格的列
            dateUpdata: '',
            dbtrue: false,

            xlfileList: [],
            CyfileList: [],
            limit: 1,
            UpfileList: [],
            DownfileList: [],
            upload: false,
            // 名族
            auNationArr: [],
            // 婚姻状态
            auMaritalArr: [
                {
                    id: 1,
                    value: "未婚",
                    key: '未婚',
                },
                {
                    id: 2,
                    value: "已婚",
                    key: '已婚',
                },
                {
                    id: 3,
                    value: "离异",
                    key: '离异',
                },
            ],
            // 户口性质
            auAddressRegisteredTypeArr: [
                {
                    id: 1,
                    value: "城镇户口",
                    key: '城镇户口',
                },
                {
                    id: 2,
                    value: "农村户口",
                    key: '农村户口',
                },
                {
                    id: 3,
                    value: "其他",
                    key: '其他',
                }
            ],
            // 政治面貌
            auPoliticalArr: [
                {
                    id: 1,
                    value: '中国共产党员',
                    key: '中国共产党员',
                },
                {
                    id: 2,
                    value: '共青团员',
                    key: '共青团员',
                },
                {
                    id: 3,
                    value: '群众',
                    key: '群众',
                },
            ],

            // 试用期
            auprobationArr: [{
                id: 0,
                value: 0,
                key: '没有使用期',
            },
            {
                id: 1,
                value: 1,
                key: '一个月',
            },
            {
                id: 2,
                value: 2,
                key: '二个月',
            },
            {
                id: 3,
                value: 3,
                key: '三个月',
            },
            {
                id: 4,
                value: 4,
                key: '四个月',
            },
            {
                id: 5,
                value: 5,
                key: '五个月',
            },
            {
                id: 6,
                value: 6,
                key: '六个月',
            },
            ],

            Related: false,
            afcTypearr: [],
            aacTypearr: [],
            aaTypearr: [],//
            amTypearr: [],//厂商
            IsSerch: false,
            dialog: false,
            edit: false,
            form: {

            },
            rules: {
                afName: [{
                    required: true,
                    message: '请输入名称',
                    trigger: 'blur'
                }
                ],
                afNumber: [{
                    required: true,
                    message: '请输入编号',
                    trigger: 'blur'
                }
                ],
            },
            DetailArr: [],
            IsDetail: false,
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            editOption2: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange2(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            tableDataCopy: [],
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    fixed: 'left',
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },

                {
                    field: "auBelong",
                    key: "auBelong",
                    title: "归属",
                    width: 80,
                    align: "center",
                    edit: false,
                    // filter: {
                    //     filterList: [

                    //     ],
                    //     isMultiple: true,
                    //     // filter confirm hook
                    //     filterConfirm: (filterList) => {
                    //         //console.log(filterList);
                    //         const labels = filterList
                    //             .filter((x) => x.selected)
                    //             .map((x) => x.label);
                    //         //console.log(labels);
                    //         this.searchByNameFieldCopy(labels, 'auBelongListString');
                    //     },
                    //     // filter reset hook
                    //     filterReset: (filterList) => {
                    //         this.searchByNameFieldCopy([], 'auBelongListString');
                    //     },
                    //     // max height
                    //     maxHeight: 200,
                    //     beforeVisibleChange: ({ nextVisible }) => {
                    //         if (nextVisible) {
                    //             this.ob(2, 'auBelong')
                    //             //console.log(nextVisible);
                    //         }
                    //     }
                    // },
                },

                {
                    field: "auName",
                    key: "auName",
                    title: "姓名",
                    align: "center",
                    fixed: 'left',
                    width: 80,
                    // filter: {
                    //     filterList: [

                    //     ],
                    //     isMultiple: true,
                    //     // filter confirm hook
                    //     filterConfirm: (filterList) => {
                    //         //console.log(filterList);
                    //         const labels = filterList
                    //             .filter((x) => x.selected)
                    //             .map((x) => x.label);
                    //         //console.log(labels);
                    //         this.searchByNameFieldCopy(labels, 'auNameListString');
                    //     },
                    //     // filter reset hook
                    //     filterReset: (filterList) => {
                    //         this.searchByNameFieldCopy([], 'auNameListString');
                    //     },
                    //     // max height
                    //     maxHeight: 200,
                    //     beforeVisibleChange: ({ nextVisible }) => {
                    //         if (nextVisible) {
                    //             this.ob(3, 'auName')
                    //             //console.log(nextVisible);
                    //         }

                    //     }
                    // },
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.getDetail(row.auId)}
                                >
                                    {row.auName}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "所在部门",
                    width: 200,
                    align: "center",
                    edit: false,
                    // filter: {
                    //     filterList: [

                    //     ],
                    //     isMultiple: true,
                    //     // filter confirm hook
                    //     filterConfirm: (filterList) => {
                    //         //console.log(filterList);
                    //         const labels = filterList
                    //             .filter((x) => x.selected)
                    //             .map((x) => x.label);
                    //         //console.log(labels);
                    //         this.searchByNameFieldCopy(labels, 'auDepartmentListString');
                    //     },
                    //     // filter reset hook
                    //     filterReset: (filterList) => {
                    //         this.searchByNameFieldCopy([], 'auDepartmentListString');
                    //     },
                    //     // max height
                    //     maxHeight: 200,
                    //     beforeVisibleChange: ({ nextVisible }) => {
                    //         if (nextVisible) {
                    //             this.ob(4, 'auDepartment')
                    //             //console.log(nextVisible);
                    //         }
                    //     }
                    // },
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="display:flex;">
                                <div style="width:100%;">{row.auDepartment}</div>
                            </div>
                        );
                    },

                },
                {
                    field: "auPost",
                    key: "auPost",
                    title: "职务",
                    align: "center",
                    width: 100,
                    edit: false,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                    },
                    // filter: {
                    //     filterList: [

                    //     ],
                    //     isMultiple: true,
                    //     // filter confirm hook
                    //     filterConfirm: (filterList) => {
                    //         //console.log(filterList);
                    //         const labels = filterList
                    //             .filter((x) => x.selected)
                    //             .map((x) => x.label);
                    //         //console.log(labels);
                    //         this.searchByNameFieldCopy(labels, 'auPostListString');
                    //     },
                    //     // filter reset hook
                    //     filterReset: (filterList) => {
                    //         this.searchByNameFieldCopy([], 'auPostListString');
                    //     },
                    //     // max height
                    //     maxHeight: 200,
                    //     beforeVisibleChange: ({ nextVisible }) => {
                    //         if (nextVisible) {
                    //             this.ob(5, 'auPost')
                    //             //console.log(nextVisible);
                    //         }
                    //     }
                    // },
                },
                {
                    field: "auSex",
                    key: "auSex",
                    title: "性别",
                    align: "center",
                    width: 70,
                    edit: false,
                    // filter: {
                    //     filterList: [

                    //     ],
                    //     isMultiple: true,
                    //     // filter confirm hook
                    //     filterConfirm: (filterList) => {
                    //         //console.log(filterList);
                    //         const labels = filterList
                    //             .filter((x) => x.selected)
                    //             .map((x) => x.label);
                    //         //console.log(labels);
                    //         this.searchByNameFieldCopy(labels, 'auSexListString');
                    //     },
                    //     // filter reset hook
                    //     filterReset: (filterList) => {
                    //         this.searchByNameFieldCopy([], 'auSexListString');
                    //     },
                    //     // max height
                    //     maxHeight: 200,
                    //     beforeVisibleChange: ({ nextVisible }) => {
                    //         if (nextVisible) {
                    //             this.ob(6, 'auSex')
                    //             //console.log(nextVisible);
                    //         }
                    //     }
                    // },
                },
                // {
                //     field: "auAge",
                //     key: "auAge",
                //     title: "年龄",
                //     align: "center",
                //     width: 100,
                //     edit: false,

                // },
                {
                    field: "auDateEntry",
                    key: "auDateEntry",
                    title: "入职时间",
                    align: "center",
                    edit: false,
                    width: 90,
                    // filter: {
                    //     filterList: [

                    //     ],
                    //     isMultiple: true,
                    //     // filter confirm hook
                    //     filterConfirm: (filterList) => {
                    //         //console.log(filterList);
                    //         const labels = filterList
                    //             .filter((x) => x.selected)
                    //             .map((x) => x.label);
                    //         //console.log(labels);
                    //         this.searchByNameFieldCopy(labels, 'auDateEntryListString');
                    //     },
                    //     // filter reset hook
                    //     filterReset: (filterList) => {
                    //         this.searchByNameFieldCopy([], 'auDateEntryListString');
                    //     },
                    //     // max height
                    //     maxHeight: 200,
                    //     beforeVisibleChange: ({ nextVisible }) => {
                    //         if (nextVisible) {
                    //             this.ob(7, 'auDateEntry')
                    //             //console.log(nextVisible);
                    //         }
                    //     }
                    // },
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.auDateEntry, 'auDateEntry', rowIndex, row.auId, 1)}>{row.auDateEntry}</div>
                            </span>
                        );
                    },
                },
                {
                    field: "auDateRegular",
                    key: "auDateRegular",
                    title: "试用期结束时间",
                    align: "center",
                    edit: false,
                    width: 90,
                    // filter: {
                    //     filterList: [

                    //     ],
                    //     isMultiple: true,
                    //     // filter confirm hook
                    //     filterConfirm: (filterList) => {
                    //         //console.log(filterList);
                    //         const labels = filterList
                    //             .filter((x) => x.selected)
                    //             .map((x) => x.label);
                    //         //console.log(labels);
                    //         this.searchByNameFieldCopy(labels, 'auDateRegularListString');
                    //     },
                    //     // filter reset hook
                    //     filterReset: (filterList) => {
                    //         this.searchByNameFieldCopy([], 'auDateRegularListString');
                    //     },
                    //     // max height
                    //     maxHeight: 200,
                    //     beforeVisibleChange: ({ nextVisible }) => {
                    //         if (nextVisible) {
                    //             this.ob(8, 'auDateRegular')
                    //             //console.log(nextVisible);
                    //         }
                    //     }
                    // },
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.auDateRegular, 'auDateRegular', rowIndex, row.auId, 1)}>{row.auDateRegular}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auDateTransfer",
                    key: "auDateTransfer",
                    title: "认证通关/调整部门时间",
                    align: "center",
                    edit: false,
                    width: 90,
                    // filter: {
                    //     filterList: [

                    //     ],
                    //     isMultiple: true,
                    //     // filter confirm hook
                    //     filterConfirm: (filterList) => {
                    //         //console.log(filterList);
                    //         const labels = filterList
                    //             .filter((x) => x.selected)
                    //             .map((x) => x.label);
                    //         //console.log(labels);
                    //         this.searchByNameFieldCopy(labels, 'auDateTransferListString');
                    //     },
                    //     // filter reset hook
                    //     filterReset: (filterList) => {
                    //         this.searchByNameFieldCopy([], 'auDateTransferListString');
                    //     },
                    //     // max height
                    //     maxHeight: 200,
                    //     beforeVisibleChange: ({ nextVisible }) => {
                    //         if (nextVisible) {
                    //             this.ob(9, 'auDateTransfer')
                    //             //console.log(nextVisible);
                    //         }
                    //     }
                    // },
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.auDateTransfer, 'auDateTransfer', rowIndex, row.auId, 1)}>{row.auDateTransfer}</div>
                            </span>
                        );
                    },

                },
                // 在职时间
                {
                    field: "auDateEntryDays",
                    key: "auDateEntryDays",
                    title: "在职时间",
                    align: "center",
                    width: 100,

                },

                {
                    field: "auStatus",
                    key: "auStatus",
                    title: "状态",
                    align: "center",
                    width: 80,
                    edit: false,
                    // filter: {
                    //     filterList: [

                    //     ],
                    //     isMultiple: true,
                    //     // filter confirm hook
                    //     filterConfirm: (filterList) => {
                    //         //console.log(filterList);
                    //         const labels = filterList
                    //             .filter((x) => x.selected)
                    //             .map((x) => x.label);
                    //         //console.log(labels);
                    //         this.searchByNameFieldCopy(labels, 'auStatusListString');
                    //     },
                    //     // filter reset hook
                    //     filterReset: (filterList) => {
                    //         this.searchByNameFieldCopy([], 'auStatusListString');
                    //     },
                    //     // max height
                    //     maxHeight: 200,
                    //     beforeVisibleChange: ({ nextVisible }) => {
                    //         if (nextVisible) {
                    //             this.ob(11, 'auStatus')
                    //             //console.log(nextVisible);
                    //         }
                    //     }
                    // },
                },
                // 转正倒计时
                {
                    field: "auProbationDays",
                    key: "auProbationDays",
                    title: "转正倒计时",
                    align: "center",
                    width: 80,

                },
                {
                    field: "auInterviewer",
                    key: "auInterviewer",
                    title: "面试官",
                    align: "center",
                    width: 80,
                    edit: false,
                    // filter: {
                    //     filterList: [

                    //     ],
                    //     isMultiple: true,
                    //     // filter confirm hook
                    //     filterConfirm: (filterList) => {
                    //         //console.log(filterList);
                    //         const labels = filterList
                    //             .filter((x) => x.selected)
                    //             .map((x) => x.label);
                    //         //console.log(labels);
                    //         this.searchByNameFieldCopy(labels, 'auInterviewerListString');
                    //     },
                    //     // filter reset hook
                    //     filterReset: (filterList) => {
                    //         this.searchByNameFieldCopy([], 'auInterviewerListString');
                    //     },
                    //     // max height
                    //     maxHeight: 200,
                    //     beforeVisibleChange: ({ nextVisible }) => {
                    //         if (nextVisible) {
                    //             this.ob(13, 'auInterviewer')
                    //             //console.log(nextVisible);
                    //         }
                    //     }
                    // },
                },
                // 服务年限

                {
                    field: "auDaysJoin",
                    key: "auDaysJoin",
                    title: "服务年限",
                    align: "center",
                    width: 80,

                },

                {
                    field: "auDateExpirationContract",
                    key: "auDateExpirationContract",
                    title: "合同到期时间",
                    align: "center",
                    edit: false,
                    width: 90,
                    // filter: {
                    //     filterList: [

                    //     ],
                    //     isMultiple: true,
                    //     // filter confirm hook
                    //     filterConfirm: (filterList) => {
                    //         //console.log(filterList);
                    //         const labels = filterList
                    //             .filter((x) => x.selected)
                    //             .map((x) => x.label);
                    //         //console.log(labels);
                    //         this.searchByNameFieldCopy(labels, 'auDateExpirationContractListString');
                    //     },
                    //     // filter reset hook
                    //     filterReset: (filterList) => {
                    //         this.searchByNameFieldCopy([], 'auDateExpirationContractListString');
                    //     },
                    //     // max height
                    //     maxHeight: 200,
                    //     beforeVisibleChange: ({ nextVisible }) => {
                    //         if (nextVisible) {
                    //             this.ob(15, 'auDateExpirationContract')
                    //             //console.log(nextVisible);
                    //         }
                    //     }
                    // },
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;;" onDblclick={() => this.getdbtrue(row.auDateExpirationContract, 'auDateExpirationContract', rowIndex, row.auId, 1)}>{row.auDateExpirationContract}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auOrigin",
                    key: "auOrigin",
                    title: "籍贯",
                    align: "center",
                    width: 100,
                    edit: false,

                },
                {
                    field: "auAddressRegistered",
                    key: "auAddressRegistered",
                    title: "户口所在地",
                    align: "center",
                    width: 100,
                    edit: false,

                },
                {
                    field: "auNation",
                    key: "auNation",
                    title: "民族",
                    align: "center",
                    width: 60,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;;" onDblclick={() => this.getdbtrue(row.auNation, 'auNation', rowIndex, row.auId, 3, this.auNationArr)}>{row.auNation}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auMarital",
                    key: "auMarital",
                    title: "婚姻状况",
                    align: "center",
                    width: 60,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;;" onDblclick={() => this.getdbtrue(row.auMarital, 'auMarital', rowIndex, row.auId, 2, this.auMaritalArr)}>{row.auMarital}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auMaritalSpouseName",
                    key: "auMaritalSpouseName",
                    title: "配偶姓名",
                    align: "center",
                    width: 80,
                    edit: false,
                },
                {
                    field: "auMaritalSpouseIdcard",
                    key: "auMaritalSpouseIdcard",
                    title: "配偶身份证号",
                    align: "center",
                    width: 150,
                    edit: false,
                },
                {
                    field: "auBirth",
                    key: "auBirth",
                    title: "出生年月",
                    align: "center",
                    edit: false,
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.auBirth, 'auBirth', rowIndex, row.auId, 1)}>{row.auBirth}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auIdcard",
                    key: "auIdcard",
                    title: "身份证号码",
                    align: "center",
                    width: 160,
                    edit: false,

                },
                {
                    field: "auIdcardLast",
                    key: "auIdcardLast",
                    title: "后四位",
                    align: "center",
                    width: 60,
                    edit: false,

                },
                {
                    field: "auIdcardIssuingAuthority",
                    key: "auIdcardIssuingAuthority",
                    title: "发证机关",
                    align: "center",
                    width: 100,
                    edit: false,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                    },
                },
                {
                    field: "auIdcardAddress",
                    key: "auIdcardAddress",
                    title: "身份证完整地址",
                    align: "center",
                    width: 150,
                    edit: false,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                    },
                },
                {
                    field: "auSchool",
                    key: "auSchool",
                    title: "毕业院校",
                    align: "center",
                    width: 100,
                    edit: false,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                    },
                },
                {
                    field: "auMajor",
                    key: "auMajor",
                    title: "专业",
                    align: "center",
                    width: 100,
                    edit: false,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                    },
                },
                {
                    field: "auEducationLevel",
                    key: "auEducationLevel",
                    title: "学历",
                    align: "center",
                    width: 100,
                    edit: false,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                    },
                },
                {
                    field: "auGraduationTime",
                    key: "auGraduationTime",
                    title: "毕业时间",
                    align: "center",
                    edit: false,
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.auGraduationTime, 'auGraduationTime', rowIndex, row.auId, 1)}>{row.auGraduationTime}</div>
                            </span>
                        );
                    },
                },
                {
                    field: "auBankCardOther",
                    key: "auBankCardOther",
                    title: "银行卡号",
                    align: "center",
                    width: 120,
                    edit: false,

                },
                {
                    field: "auContactMine",
                    key: "auContactMine",
                    title: "本人联系方式",
                    align: "center",
                    width: 100,
                    edit: false,

                },
                {
                    field: "auContactDad",
                    key: "auContactDad",
                    title: "家庭主要成员",
                    align: "center",
                    width: 300,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span onDblclick={() => this.getConact(row, 2)}>
                                <div style="width:100%;" >{row.auContactDad} {row.auContactDadUnit} {row.auContactDadPhone}</div>
                                <div style="width:100%;" >{row.auContactMom} {row.auContactMomUnit} {row.auContactMomPhone}</div>
                                {/* <div style="width:100%;" >{row.auContactSibling} {row.auContactSiblingUnit} {row.auContactSiblingPhone}</div> */}
                            </span>
                        );
                    },
                },
                {
                    field: "auContactEmergency",
                    key: "auContactEmergency",
                    title: "深圳紧急联系人姓名及联系方式",
                    align: "center",
                    width: 250,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span onDblclick={() => this.getConact(row, 3)}>
                                <div style="width:100%;" >{row.auContactEmergency} {row.auContactEmergencyPhone}</div>
                            </span>
                        );
                    },
                },
                {
                    field: "auAddressNow",
                    key: "auAddressNow",
                    title: "现居住地址",
                    align: "center",
                    width: 150,
                    edit: false,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                    },
                },
                {
                    field: "auSh",
                    key: "auSh",
                    title: "是否深户",
                    width: 80,
                    align: "center",
                    edit: false,
                },
                {
                    field: "auSocialSecurityNum",
                    key: "auSocialSecurityNum",
                    title: "社保电脑号",
                    align: "center",
                    width: 110,
                    edit: false,

                },
                {
                    field: "auProvidentFund",
                    key: "auProvidentFund",
                    title: "公积金账号",
                    align: "center",
                    width: 110,
                    edit: false,

                },
                {
                    field: "auFundOpenCityRecent",
                    key: "auFundOpenCityRecent",
                    title: "公积金缴纳城市(最近)",
                    align: "center",
                    width: 160,
                    edit: true,
                },
                {
                    field: "auFundShenzhenBefore",
                    key: "auFundShenzhenBefore",
                    title: "缴纳公积金",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "auFundOpenBank",
                    key: "auFundOpenBank",
                    title: "首开公积金卡银行",
                    align: "center",
                    width: 120,
                    edit: false,
                },
                {
                    field: "auFundOpenBankAccount",
                    key: "auFundOpenBankAccount",
                    title: "首开公积金卡卡号",
                    align: "center",
                    width: 150,
                    edit: false,
                },
                {
                    field: "auSocialSecurityDes",
                    key: "auSocialSecurityDes",
                    title: "社保备注",
                    align: "center",
                    width: 120,
                    edit: false,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auDesOther",
                    key: "auDesOther",
                    title: "其他信息",
                    align: "center",
                    width: 100,
                    edit: false,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auInformationEntry",
                    key: "auInformationEntry",
                    title: "入职资料提交情况",
                    align: "center",
                    width: 130,
                    edit: false,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                // {
                //     field: "auProbationPeriod",
                //     key: "auProbationPeriod",
                //     title: "试用期(月)",
                //     align: "center",
                //     width: 100,
                //     filter: {
                //         filterList: [

                //         ],
                //         isMultiple: true,
                //         // filter confirm hook
                //         filterConfirm: (filterList) => {
                //             //console.log(filterList);
                //             const labels = filterList
                //                 .filter((x) => x.selected)
                //                 .map((x) => x.label);
                //             //console.log(labels);
                //             this.searchByNameFieldCopy(labels, 'auProbationPeriodListString');
                //         },
                //         // filter reset hook
                //         filterReset: (filterList) => {
                //             this.searchByNameFieldCopy([], 'auProbationPeriodListString');
                //         },
                //         // max height
                //         maxHeight: 200,
                //         beforeVisibleChange: ({ nextVisible }) => {
                //             if (nextVisible) {
                //                 this.ob(10, 'auProbationPeriod')
                //                 //console.log(nextVisible);
                //             }
                //         }
                //     },
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span>
                //                 <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.auProbationPeriod, 'auProbationPeriod', rowIndex, row.auId, 2, this.auprobationArr)}>{row.auProbationPeriod}</div>
                //             </span>
                //         );
                //     },
                // },







                // {
                //     field: "auPolitical",
                //     key: "auPolitical",
                //     title: "政治面貌",
                //     align: "center",
                //     width: 100,
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span>
                //                 <div style="width:100%;height:40px;line-height:40px;;" onDblclick={() => this.getdbtrue(row.auPolitical, 'auPolitical', rowIndex, row.auId, 2, this.auPoliticalArr)}>{row.auPolitical}</div>
                //             </span>
                //         );
                //     },
                // },


                // {
                //     field: "auAddressRegisteredType",
                //     key: "auAddressRegisteredType",
                //     title: "户口性质",
                //     align: "center",
                //     width: 100,
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span>
                //                 <div style="width:100%;height:40px;line-height:40px;;" onDblclick={() => this.getdbtrue(row.auAddressRegisteredType, 'auAddressRegisteredType', rowIndex, row.auId, 2, this.auAddressRegisteredTypeArr)}>{row.auAddressRegisteredType}</div>
                //             </span>
                //         );
                //     },
                // },


                // {
                //     field: "auIdcardUp",
                //     key: "auIdcardUp",
                //     title: "身份证",
                //     align: "center",
                //     width: 350,
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span style="display:flex;align-items: center;">
                //                 <div style="width:80%;">
                //                     {
                //                         row.auIdcardUp ? <el-image ref="scrImg" id="scrimg" src={row.auIdcardUp} alt="" fit="cover" style="width: 50%;height: 50px;"
                //                             previewSrcList={[row.auIdcardUp]}></el-image> : <span></span>
                //                     }

                //                     {
                //                         row.auIdcardDown ? <el-image ref="scrImg" id="scrimg" src={row.auIdcardDown} alt="" fit="cover" style="width: 50%;height: 50px;"
                //                             previewSrcList={[row.auIdcardDown]}></el-image> : <span></span>
                //                     }
                //                 </div>
                //                 <div style="margin-left:10px">
                //                     <el-button size="mini" type="text" on-click={() => this.handleImg(row, 1)} > 编辑 </el-button>
                //                 </div>
                //             </span>
                //         );
                //     },

                // },



                // {
                //     field: "auIdcardExpiration",
                //     key: "auIdcardExpiration",
                //     title: "身份证有效期",
                //     align: "center",
                //     edit: false,
                //     width: 200,
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span>
                //                 <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.auIdcardExpiration, 'auIdcardExpiration', rowIndex, row.auId, 1)}>{row.auIdcardExpiration}</div>
                //             </span>
                //         );
                //     },
                // },


                // {
                //     field: "auCertificateEducation",
                //     key: "auCertificateEducation",
                //     title: "学历证书和查验证明",
                //     align: "center",
                //     width: 300,
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span style="display:flex;align-items: center;">
                //                 <div style="width:80%;">
                //                     {
                //                         row.auCertificateEducation ? <el-image ref="scrImg" id="scrimg" src={row.auCertificateEducation} alt="" fit="cover" style="width: 50%;height: 50px;"
                //                             previewSrcList={[row.auCertificateEducation]}></el-image> : <span></span>
                //                     }
                //                     {
                //                         row.auCertificateEducationCheck ? <el-image ref="scrImg" id="scrimg" src={row.auCertificateEducationCheck} alt="" fit="cover" style="width: 50%;height: 50px;"
                //                             previewSrcList={[row.auCertificateEducationCheck]}></el-image> : <span></span>
                //                     }
                //                 </div>
                //                 <div style="margin-left:10px">
                //                     <el-button size="mini" type="text" on-click={() => this.handleImg(row, 2)} > 编辑 </el-button>
                //                 </div>
                //             </span>

                //         );
                //     },
                // },

                // {
                //     field: "auEducationLevelMax",
                //     key: "auEducationLevelMax",
                //     title: "最高学历",
                //     align: "center",
                //     width: 100,
                //     edit: false,

                // },

                // {
                //     field: "auBankCardOther",
                //     key: "auBankCardOther",
                //     title: "其他银行",
                //     align: "center",
                //     width: 150,
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span>
                //                 <div style="width:100%;" onDblclick={() => this.getConact(row, 1)}>{row.auBankCardOther}  {row.auBankCardOtherNum}  {row.auBankCardOtherOpen}</div>
                //             </span>
                //         );
                //     },
                // },
                // {
                //     field: "auBankCardOther",
                //     key: "auBankCardOther",
                //     title: "其他银行",
                //     align: "center",
                //     width: 120,
                //     edit: false,

                // },
                // {
                //     field: "auBankCardOtherNum",
                //     key: "auBankCardOtherNum",
                //     title: "其他银行卡号",
                //     align: "center",
                //     width: 120,
                //     edit: false,

                // },
                // {
                //     field: "auBankCardOtherOpen",
                //     key: "auBankCardOtherOpen",
                //     title: "其他银行开户行",
                //     align: "center",
                //     width: 100,
                //     edit: false,
                //     ellipsis: {
                //         showTitle: true,
                //         lineClamp: 2,
                //     },
                // },

                // {
                //     field: "auEmail",
                //     key: "auEmail",
                //     title: "个人邮箱",
                //     align: "center",
                //     width: 130,
                //     edit: false,

                // },

                // {
                //     field: "auContactDad",
                //     key: "auContactDad",
                //     title: "父亲姓名",
                //     align: "center",
                //     width: 100,
                //     edit: false,

                // },
                // {
                //     field: "auContactDadUnit",
                //     key: "auContactDadUnit",
                //     title: "父亲工作单位",
                //     align: "center",
                //     width: 150,
                //     edit: false,
                //     ellipsis: {
                //         showTitle: true,
                //         lineClamp: 2,
                //     },
                // },
                // {
                //     field: "auContactDadPhone",
                //     key: "auContactDadPhone",
                //     title: "父亲联系方式",
                //     align: "center",
                //     width: 120,
                //     edit: false,

                // },
                // {
                //     field: "auContactMom",
                //     key: "auContactMom",
                //     title: "母亲姓名",
                //     align: "center",
                //     width: 100,
                //     edit: false,

                // },
                // {
                //     field: "auContactMomUnit",
                //     key: "auContactMomUnit",
                //     title: "母亲工作单位",
                //     align: "center",
                //     width: 150,
                //     edit: false,
                //     ellipsis: {
                //         showTitle: true,
                //         lineClamp: 2,
                //     },
                // },
                // {
                //     field: "auContactMomPhone",
                //     key: "auContactMomPhone",
                //     title: "母亲联系方式",
                //     align: "center",
                //     width: 120,
                //     edit: false,

                // },
                // {
                //     field: "auContactSibling",
                //     key: "auContactSibling",
                //     title: "兄弟姐妹姓名",
                //     align: "center",
                //     width: 100,
                //     edit: false,

                // },
                // {
                //     field: "auContactSiblingUnit",
                //     key: "auContactSiblingUnit",
                //     title: "兄弟姐妹工作单位",
                //     align: "center",
                //     width: 150,
                //     edit: false,
                //     ellipsis: {
                //         showTitle: true,
                //         lineClamp: 2,
                //     },
                // },
                // {
                //     field: "auContactSiblingPhone",
                //     key: "auContactSiblingPhone",
                //     title: "兄弟姐妹联系方式",
                //     align: "center",
                //     width: 120,
                //     edit: false,

                // },

                // {
                //     field: "auContactEmergency",
                //     key: "auContactEmergency",
                //     title: "深圳紧急联系人姓名及联系方式",
                //     align: "center",
                //     width: 150,
                //     edit: false,

                // },
                // {
                //     field: "auContactEmergencyUnit",
                //     key: "auContactEmergencyUnit",
                //     title: "深圳紧急联系人工作单位",
                //     align: "center",
                //     width: 180,
                //     edit: false,
                //     ellipsis: {
                //         showTitle: true,
                //         lineClamp: 2,
                //     },
                // },
                // {
                //     field: "auContactEmergencyPhone",
                //     key: "auContactEmergencyPhone",
                //     title: "深圳紧急联系人联系方式",
                //     align: "center",
                //     width: 180,
                //     edit: false,

                // },

                // {
                //     field: "auLeaveReason",
                //     key: "auLeaveReason",
                //     title: "离职原因",
                //     align: "center",
                //     width: 120,
                //     edit: false,
                //     ellipsis: {
                //         showTitle: true,
                //         lineClamp: 2,
                //     },
                // },
                // {
                //     field: "auLevelDate",
                //     key: "auLevelDate",
                //     title: "离职日期",
                //     align: "center",
                //     edit: false,
                //     width: 200,
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span>
                //                 <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.auLevelDate, 'auLevelDate', rowIndex, row.auId, 1)}>{row.auLevelDate}</div>
                //             </span>
                //         );
                //     },

                // },
                // {
                //     field: "auPayStatus",
                //     key: "auPayStatus",
                //     title: "是否发薪",
                //     align: "center",
                //     width: 100,
                //     edit: false,

                // },
                // {
                //     field: "auDesLeaveSocialSecurityDes",
                //     key: "auDesLeaveSocialSecurityDes",
                //     title: "社保备注(离职)",
                //     align: "center",
                //     width: 100,
                //     edit: false,
                //     ellipsis: {
                //         showTitle: true,
                //         lineClamp: 2,
                //     },
                // },
                // {
                //     field: "auEvaluateMime",
                //     key: "auEvaluateMime",
                //     title: "兴趣爱好和自我评价",
                //     align: "center",
                //     width: 150,
                //     edit: false,
                //     ellipsis: {
                //         showTitle: true,
                //         lineClamp: 2,
                //     },
                // },



                // {
                //     field: "afDes",
                //     key: "afDes",
                //     title: "备注",
                //     align: "center",
                //     edit: false,
                //     width: 150,
                //     ellipsis: {
                //         showTitle: true,
                //         lineClamp: 2,
                //     },
                // },
                {
                    field: "auAssetsConfirm",
                    key: "auAssetsConfirm",
                    title: "设备领用确认状态",
                    align: "center",
                    width: 150,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.auAssetsConfirm == 1 ? (
                                    <el-tag size="mini" type="danger">
                                        未确认
                                    </el-tag>
                                ) : row.auAssetsConfirm == 2 ? (
                                    <el-tag size="mini" type="success">
                                        已确认
                                    </el-tag>
                                ) : ''}

                            </span>
                        )
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },

                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 250,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {/* {
                                    row.checkStatus == 2 ? <el-button size="mini" type="text" style="color: red" on-click={() => this.levelDate(row)}>离职</el-button> : <span></span>
                                } */}

                                {/* <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handWord(row)}
                                >
                                    导出word
                                </el-button> */}
                                {/* <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.transferClick(row)}
                                >
                                    转岗
                                </el-button> */}


                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                {/* <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button> */}
                                {row.auAssetsConfirm == 1 ? <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red;margin-left:10px;"
                                    on-click={() => this.handleHistory(row)}
                                >
                                    设备借用确认
                                </el-button> : ''}
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            auId: '',
            formDatas: {
                auNameListString: '',
                auBelongListString: '',
                auDepartmentListString: '',
                auPostListString: '',
                auSexListString: '',
                auDateEntryListString: '',
                auProbationPeriodListString: '',
                auDateRegularListString: '',
                auDateTransferListString: '',
                auStatusListString: '',
                auInterviewerListString: '',
                auDateExpirationContractListString: '',



                auName: '',
                auBelong: '',
                auDepartment: '',
                auPost: '',
                auSex: '',
                auIdcard: '',
                auAgeStart: '',
                auAgeEnd: '',
                auDateEntryStart: '',
                auDateEntryEnd: '',
                auStatus: '',
                auInterviewer: '',
                auAddressRegisteredType: '',
                auIdcardExpirationStart: '',
                auIdcardExpirationEnd: '',
                auSchool: '',
                auMajor: '',
                auEducationLevel: '',
                auGraduationTimeStart: '',
                auGraduationTimeEnd: '',
                auEducationLevelMax: '',
                auContactMine: '',
                auSocialSecurityNum: '',
                auProvidentFund: '',
                auInformationEntry: '',
                checkStatus: '',
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.iuId = localStorage.getItem("iuId");
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getSysNationList().then(res => {
            this.auNationArr = res.data
        })
        getAjUserBelongList().then(res => {
            this.aubName_arr = res.data
        })
        getSysRegionList().then(res => {
            res.data.forEach((item, index) => {
                const obj = {
                    value: item.srCode,
                    label: item.srName,
                    children: [],
                }
                this.auOriginArr.push(obj)
            })

        })
        // getAjUserDepartmentList({ pageSize: 0 }).then((res) => {
        //     res.data.forEach((item, index) => {
        //         const s = {
        //             value: item.audId,
        //             label: item.audName,
        //         }
        //         if (item.ajUserDepartmentListChild.length > 0) {
        //             s.children = []
        //             item.ajUserDepartmentListChild.forEach((data, id) => {
        //                 const ss = {
        //                     value: data.audId,
        //                     label: data.audName,
        //                 }

        //                 s.children.push(ss)
        //             })
        //         };
        //         this.auDepartmentArr.push(s)
        //     })
        // });

        this.getList();
    },
    mounted() {


    },
    methods: {
        sheBeiClose() {
            this.IsHistory = false;
            this.theAuAssetsId = '';
            this.getList();
        },
        sureSheBei() {
            this.$confirm("是否确定?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjUserAssetsConfirm({ auAssetsId: this.theAuAssetsId, handlerUser: this.theUser }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: '成功',
                            });
                            this.sheBeiClose()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        IsdepartmentClick() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.Isdepartment = true;
            }
        },
        IsdepartmentClose() {
            this.Isdepartment = false
            this.auDepartment = '';
        },
        sureIsdepartment() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var formdata = this.auDepartment[0] || this.auDepartment;
                    if (this.auDepartment.length > 1) {
                        formdata = this.auDepartment[this.auDepartment.length - 1]
                    }
                    updateAjUserDepartments({ audId: formdata, auIds: this.selectedRowKeysCollection.toString() }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: '编辑成功',
                            });
                            this.checkboxOption.selectedRowKeys = this.selectedRowKeysCollection = [];
                            this.IsdepartmentClose()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        batchHand() {
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/aj-user-other/getAjUserHeaderFile',
                data: '',
                withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('iuId')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/x-zip-compressed"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '头像.zip');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })

        },
        batchWord() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && this.selectedRowKeysCollection.length < 2) {
                //console.log('开始导出', this.selectedRowKeysCollection)
                this.openLoading()
                const bulkdata = {
                    auIds: this.selectedRowKeysCollection.toString()
                }
                var s = qs.stringify(bulkdata);
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/aj-user/exportAjUserWord',
                    data: s,
                    withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('iuId')
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.documentl"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '花名册.doc');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
            } else {
                //console.log('开始导出', this.selectedRowKeysCollection)
                this.openLoading()
                const bulkdata = {
                    auIds: this.selectedRowKeysCollection.toString()
                }
                var s = qs.stringify(bulkdata);
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/aj-user/exportAjUserWord',
                    data: s,
                    withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('iuId')
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/x-zip-compressed"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '花名册.zip');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
            }
        },
        IsupdataClose() {
            this.Isupdata = false;
            this.updataData = []
            this.updatamsg = '暂无数据';
            this.getList();
        },
        SynchronizeUpdates() {
            this.openLoading()

            getAssetsAjUserSyn({ auIds: this.selectedRowKeysCollection.toString() })
                .then(res => {
                    if (res.data == "2") {
                        this.loadings.close();
                        this.$message({
                            type: "wraning",
                            message: "用户已审核!",
                        });
                    } else if (Array.isArray(res.data)) {
                        this.loadings.close();
                        this.Isupdata = true;
                        this.updataData = res.data;
                    } else {
                        this.loadings.close();
                        this.Isupdata = true;
                        this.updatamsg = res.data;

                    }
                })

        },
        transferShowClose() {
            this.transferShow = false;
            this.getList()
        },
        transferList() {
            getAjUserPostRecordList({ auId: this.auId }).then(res => {
                this.transferData = res.data;
            })
        },
        transferEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.formTf = data;
            this.editTf = true;
            this.AddtransferShow = true;
        },
        AddtransferClick() {
            this.formTf.auId = this.auId;
            this.AddtransferShow = true;
            this.editTf = false;
        },
        transferClose() {
            this.formTf = {
                auprId: '',
                auprNameTo: '',
                auprNameDtTo: '',
                auprDate: '',
            };
            this.AddtransferShow = false;
        },
        transferSure() {
            if (this.editTf) {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjUserPostRecord(this.formTf).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "成功!",
                                });
                                this.transferClose()
                                this.transferList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要新增吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjUserPostRecord(this.formTf).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "成功!",
                                });
                                this.transferClose()
                                this.transferList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        transferClick(row) {
            this.auId = row.auId;
            getAjUserPostRecordList({ auId: row.auId }).then(res => {
                this.transferData = res.data;
                this.transferShow = true;
            })
        },
        async ob(i, item) {
            const filterarr = []
            const data = await getAjUserItem({ item, itemStatus: 1 })

            if (this.formDatas[item + 'ListString']) {
                const arr = this.formDatas[item + 'ListString'].split(',')
                arr.forEach((datas, i) => {
                    data.data.forEach((ite, index) => {
                        if (datas == ite.name) {
                            //console.log(datas);
                            const s = {
                                label: ite.name + `(${ite.num})`,
                                selected: true,
                                value: index
                            }
                            filterarr.push(s)

                        }
                        const s = {
                            label: ite.name + `(${ite.num})`,
                            selected: true,
                            value: index
                        }
                        filterarr.push(s)
                    })
                })
                let map = new Map();
                let filterList = []
                for (let itt of filterarr) {
                    map.set(itt.id, itt)
                }
                filterList = [...map.values()]
                filterarr = filterList
            } else {
                data.data.forEach((ite, index) => {
                    //console.log('初始化');
                    const s = {
                        label: ite.name + `(${ite.num})`,
                        selected: false,
                        value: index
                    }
                    filterarr.push(s)
                })
            }
            this.$nextTick(() => {
                this.$set(this.columns[i].filter, 'filterList', filterarr)
                this.$refs['vetable'].colgroups[i].filter.filterList = filterarr

            })
        },
        CloseConact() {
            this.IsConact = false;
            this.conactType = 0;
        },
        sureConact() {
            if (this.conactType == 1) {
                // 银行卡信息编辑
                updateAjUserBank(this.form).then(res => {
                    if (res.data) {
                        this.$message({
                            type: "success",
                            message: "成功!",
                        });
                        this.CloseConact()
                        this.getList()
                    }
                })
            } else {
                // 家庭信息编辑
                updateAjUserContact(this.form).then(res => {
                    if (res.data) {
                        this.$message({
                            type: "success",
                            message: "成功!",
                        });
                        this.CloseConact()
                        this.getList()
                    }
                })
            }
        },
        getConact(row, type) {
            this.form = JSON.parse(JSON.stringify(row));
            this.conactType = type;
            this.IsConact = true;
        },
        CloseLevel() {
            this.formLevel = {};
            this.IsLevel = false;
        },
        sureLevel() {
            this.$confirm("是否确定要离职吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjUserLeave(this.formLevel).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "离职成功!",
                            });
                            this.CloseLevel()
                            this.getList()
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        levelDate(row) {
            this.IsLevel = true;
            this.formLevel.auId = row.auId
            this.form.auId = row.auId
        },
        Closeword() {
            this.IsWord = false;
            this.wordtypenum = 1;
            this.wordType = '';
        },
        sureword() {
            exportAjUserWord({
                auId: this.auId, auwId: this
                    .wordType
            }).then(res => {
                if (res.data) {

                    window.location.href = res.data;
                    this.$message({
                        type: "success",
                        message: '导出成功',
                    });
                    this.Closeword()
                }
            })
        },
        Handleword() {
            getAjUserWordList().then(res => {
                this.wordData = res.data;
                this.IsWord = true;
                this.wordtypenum = 1
            })

        },
        expandChange(e) {
            //console.log(e);


        },
        handleChange(value) {
            //console.log(value);
            let nodesInfo = this.$refs['cascader'].getCheckedNodes()
            this.form.auOrigin = nodesInfo[0].pathLabels.join('/');
            //console.log(this.form.auOrigin, nodesInfo)
        },
        expandChange2(e) {
            //console.log(e);


        },
        handleChange2(value) {
            //console.log(value);
            let nodesInfo = this.$refs['cascader2'].getCheckedNodes()
            this.form.auAddressNow = nodesInfo[0].pathLabels.join(' ');
            //console.log(this.form.auAddressNow, nodesInfo)
        },
        sureImg() {
            if (this.type == 1) {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const s = {
                            auId: this.auId,
                            auIdcardUp: this.form.auIdcardUp,
                            auIdcardDown: this.form.auIdcardDown
                        }
                        updateAjUserIdCard(s).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const s = {
                            auId: this.auId,
                            auCertificateEducation: this.form.auCertificateEducation,
                            auCertificateEducationCheck: this.form.auCertificateEducationCheck
                        }
                        updateAjUserCertificate(s).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

            // 
        },

        handleImg(row, type) {
            this.auId = row.auId;
            this.type = type;
            this.IsImg = true;
            const data = JSON.parse(JSON.stringify(row))
            this.$nextTick(() => {
                const obj = {
                    UpfileList: 'auIdcardUp',
                    DownfileList: 'auIdcardDown',
                    xlfileList: 'auCertificateEducation',
                    CyfileList: 'auCertificateEducationCheck'
                }
                for (let item in obj) {
                    for (let key in data) {
                        if (key == obj[item] && data[key]) {
                            //console.log(data[obj[item]]);
                            const img = {
                                name: data[obj[item]],
                                url: data[obj[item]],
                            }
                            this.$set(this[item], 0, img)
                        }
                    }
                }
            })
        },
        handleHistory(row) {
            if (!row.auAssetsId) {
                this.$message({
                    showClose: true,
                    message: "花名册关联失败,请联系管理员处理",
                    type: 'danger'
                });
                return
            }
            this.theAuAssetsId = row.auAssetsId;
            getAjUserBorrowApplyList({ auId: row.auAssetsId }).then(res => {
                this.HistoryData = res.data;
                this.IsHistory = true;
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },

        Out(command) {
            //console.log(command);
            if (this.selectedRowKeysCollection.length == 0 && !command) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && !command) {
                //console.log('开始导出', this.selectedRowKeysCollection)
                this.openLoading()
                exportAjUser({ userStatus: 1, auIds: this.selectedRowKeysCollection.toString() }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });
                        this.checkboxOption.selectedRowKeys = this.selectedRowKeysCollection = []

                    }
                })
            } else {
                this.openLoading()
                exportAjUser({ userStatus: 1, exportType: 1 }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });


                    }
                })
            }
        },


        searchByNameField(labels, id) {
            this.bulkData = this.bulkDataCopy.filter(
                (x) => labels.length === 0 || labels.includes(x[id]),
            );
        },
        searchByNameFieldCopy(labels, id) {
            if (labels == []) {
                this.formDatas[id] = '';

                this.partserch()
                return
            }
            const arr = labels
            labels.forEach((item, index) => {
                const a = item.indexOf('(');
                arr[index] = item.substring(0, a);

            })
            this.formDatas[id] = arr.toString();

            this.partserch()
            // this.bulkData = this.bulkDataCopy.filter(
            //     (x) => labels.length === 0 || labels.includes(x[id]),
            // );
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjUser({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()

                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {

            //console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjUser(Data).then(res => {
                //console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];

                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        filterTag(value, row) {
            return row.status == value;
        },
        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },

        handWord(row) {
            this.auId = row.auId
            getAjUserWordList().then(res => {
                this.wordData = res.data;

            })
            this.IsWord = true;
            this.wordtypenum = 2

        },
        sureDate() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(this.dateKeys, this.dateUpdata);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.auId = this.keysId
                    updateAjUser(jsonObj).then(res => {
                        if (res.status == 200) {
                            this.$nextTick(() => {
                                //console.log(this.tableData[this.dateIndexs], this.dateKeys);
                                this.tableData[this.dateIndexs][this.dateKeys] = this.dateUpdata
                            });
                            this.dbtrue = false;
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                        }

                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        getdbtrue(val, key, index, id, typeid, Arr) {
            //console.log("双击", val, key, index);
            this.dbtrue = true;
            this.dateUpdata = val;
            this.dateKeys = key;
            this.dateIndexs = index;
            this.keysId = id;
            this.TypeId = typeid;
            this.EditArr = Arr

        },

        handleCheck(row) {
            this.$confirm("是否确定要审核通过吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjUserCheck({ auId: row.auId }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });

                        this.getList()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        XlfileChange(file) {
            this.$set(this.form, 'auCertificateEducation', file[0])
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        CyfileChange(file) {
            this.$set(this.form, 'auCertificateEducationCheck', file[0])
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        UpremoveAfter() {
            this.form.auNation = '';
            this.form.auBirth = '';
            this.form.auIdcard = '';
            this.form.auIdcardAddress = '';
            this.form.auOrigin = '';
            this.form.auIdcardUp = '';
        },
        DownremoveAfter() {
            this.form.auIdcardIssuingAuthority = '';
            this.form.auIdcardExpiration = '';
            this.form.auIdcardDown = '';
        },
        auIdcardUpfileChange(file) {
            //console.log(file);
            if (file[0].idCardInfo) {
                getAjUserDetails({ auIdcard: file[0].idCardInfo.idCardNum }).then(res => {
                    if (res.data && res.data != '资料已审核') {
                        // this.$confirm("该身份证已经存在, 点击确定继续修改,点击取消重新填写?", "提示", {
                        //     confirmButtonText: "确定",
                        //     cancelButtonText: "取消",
                        //     type: "warning",
                        // })
                        //     .then(() => {
                        //         this.$nextTick(() => {
                        //             const sss = JSON.parse(JSON.stringify(res.data))
                        //             this.form = sss;
                        //             this.auOriginPL = res.data.auOrigin;
                        //             const arr = res.data.auEducationLevel.split(' ');

                        //             this.education = arr[0]
                        //             this.form.auEducationLevel = arr[1]
                        //             //console.log(arr);
                        //             const reg = /.+?(省|市|自治区|自治州|县|区)/g // 省市区的正则
                        //             if (res.data.auAddressNow) {
                        //                 const adress = res.data.auAddressNow.match(reg)
                        //                 const area = adress[0] + adress[1] + adress[2]
                        //                 this.auAddressNowPL = area
                        //             }
                        //             // // 判断银行
                        //             // if (res.data.auBankCardPf) {
                        //             //     this.bankShow = 1
                        //             // } else if (res.data.auBankCardOther || res.data.auBankCardOtherNum || res.data.auBankCardOtherOpen) {
                        //             //     this.bankShow = 2
                        //             // }
                        //             // if (res.data.auContactDad) {
                        //             //     this.familyShow.push('1')

                        //             // } else if (res.data.auContactMom) {
                        //             //     this.familyShow.push('2')
                        //             // } else if (res.data.auContactSibling) {
                        //             //     this.familyShow.push('3')
                        //             // }
                        //             const obj = {
                        //                 UpfileList: 'auIdcardUp',
                        //                 DownfileList: 'auIdcardDown',
                        //                 xlfileList: 'auCertificateEducation',
                        //                 CyfileList: 'auCertificateEducationCheck'
                        //             }
                        //             for (let item in obj) {
                        //                 if (res.data[obj[item]]) {
                        //                     const img = {
                        //                         name: res.data[obj[item]],
                        //                         url: res.data[obj[item]],
                        //                     }
                        //                     this.$set(this[item], 0, img)
                        //                 }
                        //             }
                        //             if (!sss.auIdcardUp) {
                        //                 this.$set(this.form, 'auIdcardUp', file[0].idCardInfo.cardImageFront || file[0].address)
                        //             }

                        //         })

                        //     }).catch(() => {
                        this.$nextTick(() => {
                            const reg = /.+?(省|市|自治区|自治州|县|区)/g // 省市区的正则
                            const adress = file[0].idCardInfo.address.match(reg)
                            const area = adress[0] + adress[1] + adress[2]
                            this.$set(this.form, 'auOrigin', area)
                            // this.$set(this.auOriginvalue,area)
                            this.auOriginPL = area;
                            this.$forceUpdate()
                            const img = {
                                name: file[0].idCardInfo.cardImageFront,
                                url: file[0].idCardInfo.cardImageFront,
                            }
                            this.$set(this.UpfileList, 0, img)
                            this.$set(this.form, 'auAddressRegistered', file[0].idCardInfo.addressSimple)
                            this.$set(this.form, 'auNation', file[0].idCardInfo.nation + '族')
                            this.$set(this.form, 'auBirth', file[0].idCardInfo.birth)
                            this.$set(this.form, 'auIdcard', file[0].idCardInfo.idCardNum)
                            this.$set(this.form, 'auIdcardAddress', file[0].idCardInfo.address)
                            this.$set(this.form, 'auIdcardUp', file[0].idCardInfo.cardImageFront || file[0].address)
                            this.$set(this.form, 'auName', file[0].idCardInfo.name)
                            this.$set(this.form, 'auSex', file[0].idCardInfo.sex)
                            this.$set(this.form, 'auAge', file[0].idCardInfo.age)
                            //console.log(this.form);
                            //console.log(file[0].idCardInfo.address.match(reg))
                            // auAddressRegistered
                        })
                        // })

                    } else {
                        //console.log('11');
                        this.$nextTick(() => {
                            const reg = /.+?(省|市|自治区|自治州|县|区)/g // 省市区的正则
                            const adress = file[0].idCardInfo.address.match(reg)
                            const area = adress[0] + adress[1] + adress[2]
                            this.$set(this.form, 'auOrigin', area)
                            this.auOriginPL = area;
                            const img = {
                                name: file[0].idCardInfo.cardImageFront,
                                url: file[0].idCardInfo.cardImageFront,
                            }
                            this.$set(this.UpfileList, 0, img)
                            this.$set(this.form, 'auAddressRegistered', file[0].idCardInfo.addressSimple)
                            this.$set(this.form, 'auNation', file[0].idCardInfo.nation + '族')
                            this.$set(this.form, 'auBirth', file[0].idCardInfo.birth)
                            this.$set(this.form, 'auIdcard', file[0].idCardInfo.idCardNum)
                            this.$set(this.form, 'auIdcardAddress', file[0].idCardInfo.address)
                            this.$set(this.form, 'auIdcardUp', file[0].idCardInfo.cardImageFront || file[0].address)
                            this.$set(this.form, 'auName', file[0].idCardInfo.name)
                            this.$set(this.form, 'auSex', file[0].idCardInfo.sex)
                            this.$set(this.form, 'auAge', file[0].idCardInfo.age)
                            //console.log(this.form);
                            //console.log(file[0].idCardInfo.address.match(reg))
                        })
                        this.$message({
                            type: "success",
                            message: "上传成功!",
                        });
                    }
                })

            } else {
                this.$message({
                    type: "danger",
                    message: "上传失败!",
                });
            }
        },
        auIdcardUpfileChangeTwo(file) {
            //console.log(file);
            if (file[0].idCardInfo) {
                this.$nextTick(() => {
                    const img = {
                        name: file[0].idCardInfo.cardImageFront,
                        url: file[0].idCardInfo.cardImageFront,
                    }
                    this.$set(this.UpfileList, 0, img)
                    this.$set(this.form, 'auNation', file[0].idCardInfo.nation + '族')
                    this.$set(this.form, 'auBirth', file[0].idCardInfo.birth)
                    this.$set(this.form, 'auIdcard', file[0].idCardInfo.idCardNum)
                    this.$set(this.form, 'auIdcardAddress', file[0].idCardInfo.address)
                    this.$set(this.form, 'auOrigin', file[0].idCardInfo.addressSimple)
                    this.$set(this.form, 'auIdcardUp', file[0].idCardInfo.cardImageFront || file[0].address)
                    this.$set(this.form, 'auName', file[0].idCardInfo.name)
                    this.$set(this.form, 'auSex', file[0].idCardInfo.sex)
                    this.$set(this.form, 'auAge', file[0].idCardInfo.age)
                    //console.log(this.form);
                })
            } else {
                this.$message({
                    type: "danger",
                    message: "上传失败!",
                });
            }
        },
        auIdcardDownfileChange(file) {
            if (file[0].idCardInfo) {
                this.$nextTick(() => {
                    this.$set(this.form, 'auIdcardIssuingAuthority', file[0].idCardInfo.issuingAuthority)
                    this.$set(this.form, 'auIdcardExpiration', file[0].idCardInfo.expirationDate)
                    this.$set(this.form, 'auIdcardDown', file[0].idCardInfo.cardImageBack || file[0].address)
                    //console.log(this.form);
                })
                this.$message({
                    type: "success",
                    message: "上传成功!",
                });
            } else {
                this.$message({
                    type: "danger",
                    message: "上传失败!",
                });
            }

        },
        sureRelated() {
            this.$confirm("是否确定要添加吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjFittinsgAssets({ auId: this.DetailArr.auId, aaId: this.form.aaId }).then(res => {
                        if (res.data) {
                            this.Related = false;
                            this.getDetail(this.DetailArr.auId)
                            this.$message({
                                type: "success",
                                message: "添加成功!",
                            });
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        addRelated() {
            this.form.aaId = this.DetailArr.ajAssets.aaId || '';
            this.Related = true;
        },
        removeRelated() {
            this.$confirm("是否确定要解除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjFittingsAssetsUnbinding({ auId: this.DetailArr.auId }).then(res => {
                        if (res.data) {
                            this.Related = false;
                            this.getDetail(this.DetailArr.auId)
                            this.$message({
                                type: "success",
                                message: "解除成功!",
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        closeSizer() {
            this.formDatas = {
                auName: '',
                auBelong: '',
                auDepartment: '',
                auPost: '',
                auSex: '',
                auIdcard: '',
                auAgeStart: '',
                auAgeEnd: '',
                auDateEntryStart: '',
                auDateEntryEnd: '',
                auStatus: '',
                auInterviewer: '',
                auAddressRegisteredType: '',
                auIdcardExpirationStart: '',
                auIdcardExpirationEnd: '',
                auSchool: '',
                auMajor: '',
                auEducationLevel: '',
                auGraduationTimeStart: '',
                auGraduationTimeEnd: '',
                auEducationLevelMax: '',
                auContactMine: '',
                auSocialSecurityNum: '',
                auProvidentFund: '',
                auInformationEntry: '',
                checkStatus: '',

                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            };
            this.IsSerch = false;
            this.partserch()
        },
        SerchMore() {
            this.IsSerch = true;
        },
        getDetail(id) {
            getAjUserDetails({ auId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                //console.log(this.DetailArr);
            });

        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjUser({ auIds: row.auId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                const arr = data.auEducationLevel.split(' ');
                this.education = arr[0]
                this.form.auEducationLevel = arr[1]
                this.auOriginPL = data.auOrigin;
                const reg = /.+?(省|市|自治区|自治州|县|区)/g // 省市区的正则
                // 判断银行
                if (data.auBankCardPf) {
                    this.bankShow = 1
                } else if (data.auBankCardOther || data.auBankCardOtherNum || data.auBankCardOtherOpen) {
                    this.bankShow = 2
                }
                if (data.auContactDad) {
                    this.familyShow.push('1')
                } else if (data.auContactMom) {
                    this.familyShow.push('2')
                } else if (data.auContactSibling) {
                    this.familyShow.push('3')
                }
                if (data.auAddressNow) {

                    const adress = data.auAddressNow.match(reg)
                    const area = adress[0] + adress[1] + adress[2]
                    this.auAddressNowPL = area
                }

                const obj = {
                    UpfileList: 'auIdcardUp',
                    DownfileList: 'auIdcardDown',
                    xlfileList: 'auCertificateEducation',
                    CyfileList: 'auCertificateEducationCheck'
                }
                for (let item in obj) {
                    for (let key in data) {
                        if (key == obj[item] && data[key]) {
                            //console.log(data[obj[item]]);
                            const img = {
                                name: data[obj[item]],
                                url: data[obj[item]],
                            }
                            this.$set(this[item], 0, img)
                        }
                    }
                }
            })

        },
        SureBtn() {
            if (!this.edit) {
                this.form.auEducationLevel = this.education + ' ' + this.form.auEducationLevel;
                //console.log(this.form.auEducationLevel);
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjUser(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.form.auEducationLevel = this.education + ' ' + this.form.auEducationLevel
                        updateAjUser(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        CloseImg() {
            this.IsImg = false;
            //console.log(this.$refs.upcard2);
            setTimeout(() => {
                this.$refs.upcard2.fileAllRemove()
                this.$refs.Downcard2.fileAllRemove()
                this.$refs.xlupload2.fileAllRemove()
                this.$refs.Cyupload2.fileAllRemove()
                this.UpfileList = [];
                this.DownfileList = [];
                this.xlfileList = [];
                this.CyfileList = [];
            }, 10)
            // this.$nextTick(() => {

            // })


        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            //console.log(this.$refs.upcard);
            this.IsImg = false;
            this.bankShow = '';
            this.familyShow = [];
            this.$nextTick(() => {
                this.$refs['formRef'].resetFields();
                this.$refs.upcard.fileAllRemove()
                this.$refs.Downcard.fileAllRemove()
                this.$refs.xlupload.fileAllRemove()
                this.$refs.Cyupload.fileAllRemove()
                this.auAddressNowvalue = '';
                this.auOriginvalue = '';
                this.auAddressNowPL = '请选择地区';
                this.auOriginPL = '请选择地区';
                this.UpfileList = [];
                this.DownfileList = [];
                this.xlfileList = [];
                this.CyfileList = [];
            })


        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.auId = row.auId
                    //console.log(jsonObj);
                    updateAjUser(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        async beforeCellValChange2(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.auwId = row.auwId
                    //console.log(jsonObj);
                    updateAjUserWord(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.wordData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // //console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.auId) > -1) {
                        //console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.auId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            //console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.auId) > -1) {
                        this.selectedRowKeysCollection.splice(index, 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.auId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            //console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            this.formDatas.checkStatus = 2;
            getAjUserListUnCheck(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.tableDataCopy = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.formDatas.checkStatus = 2;
            getAjUserListUnCheck(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.tableDataCopy = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });
        },
        getList() {
            this.formDatas.checkStatus = 2;
            getAjUserListUnCheck(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.tableDataCopy = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-body-tr td.ve-table-body-td,
.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-expand-tr td.ve-table-body-td {
    padding: 0 !important;
    line-height: 1 !important;
}
</style>